// Generated by scripts/build-day-events.js from refreshed tournament seed. Do not hand-edit.
module.exports = [
  {
    "casino": "101 Poker Club",
    "day": "Mondays",
    "name": "$100 Freezeout",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "101 Poker Club",
    "day": "Sundays",
    "name": "PLO Bomb Pots",
    "start": "1:05pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "101 Poker Club",
    "day": "Tuesdays, Thursdays",
    "name": "$60 ROE",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "101 Poker Club",
    "day": "Wednesdays",
    "name": "$100 Freezeout",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "4 Bears Casino & Lodge",
    "day": "Saturdays",
    "name": "NLH w/ $5 Rebuys",
    "start": "2:00pm",
    "buyin": "$20",
    "state": "North Dakota"
  },
  {
    "casino": "4 Bears Casino & Lodge",
    "day": "Wednesdays, Thursdays, Fridays",
    "name": "NLH w/ $5 Rebuys",
    "start": "7:00pm",
    "buyin": "$20",
    "state": "North Dakota"
  },
  {
    "casino": "Ace's Poker Lakewood",
    "day": "Fridays, Saturdays, Sundays",
    "name": "$120 NL Holdem",
    "start": "4:00pm",
    "buyin": "$120",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Lakewood",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "$50 NL Holdem",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Fridays",
    "name": "No-Limit Hold'em",
    "start": "10:00am",
    "buyin": "$150",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Mondays, Tuesdays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Sundays",
    "name": "No-Limit Hold'em",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Saturdays",
    "name": "No-Limit Hold'em",
    "start": "10:00am",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Saturdays",
    "name": "No-Limit Hold'em",
    "start": "2:00pm",
    "buyin": "$200",
    "state": "Washington"
  },
  {
    "casino": "Ace's Poker Mountlake Terrace",
    "day": "Wednesdays",
    "name": "Green Chip Bounty",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Agua Caliente Casino, Palm Springs",
    "day": "Saturdays",
    "name": "Daily Poker Tournament",
    "start": "11am",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Agua Caliente Casino, Palm Springs",
    "day": "Sundays, Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Daily Poker Tournament",
    "start": "11am",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Agua Caliente Casino, Palm Springs",
    "day": "Tuesdays, Thursdays",
    "name": "Nightly Poker Tournament",
    "start": "11am",
    "buyin": "$75",
    "state": "California"
  },
  {
    "casino": "Agua Caliente Casino, Palm Springs",
    "day": "Wednesdays (first each month)",
    "name": "Monthly Freeroll Poker Tournament",
    "start": "12pm OR 6pm (choose ONE)",
    "buyin": "Free (see qualification details below)",
    "state": "California"
  },
  {
    "casino": "Alamo City Poker Club",
    "day": "Sundays (third each month)",
    "name": "King of Kings Complimentary Tournament",
    "buyin": "Free",
    "state": "Texas"
  },
  {
    "casino": "Alamo City Poker Club",
    "day": "Thursdays",
    "name": "Thursday Ladies' Night NLH",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "All Star Casino",
    "day": "Fridays, Saturdays, Sundays",
    "name": "NLH",
    "start": "4:00pm",
    "buyin": "$120",
    "state": "Washington"
  },
  {
    "casino": "All Star Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "NLH",
    "start": "11:00am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "All Star Casino",
    "day": "Sundays",
    "name": "Sunday Evening NLH $60+$10",
    "start": "5:00pm",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "All Star Casino",
    "day": "Thursdays",
    "name": "Thursday Evening NLH $60+$10",
    "start": "7:00pm",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "All Star Casino",
    "day": "Tuesdays",
    "name": "Tuesday Evening NLH $60+$10",
    "start": "7:00pm",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Fridays",
    "name": "Friday 30 for 30K $31 / $500 GTD",
    "start": "1:00pm",
    "buyin": "$31",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Fridays",
    "name": "Friday Night NLH $51 / $500 GTD",
    "start": "6:30pm",
    "buyin": "$51",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Mondays",
    "name": "Monday NLH Freezeout $66 / $500 GTD",
    "start": "1:00pm",
    "buyin": "$66",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Saturdays",
    "name": "Saturday Midday $101 / $2K GTD",
    "start": "1:00pm",
    "buyin": "$101",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Saturdays",
    "name": "Saturday NLH Freezeout $81 / $1K GTD",
    "start": "5:00pm",
    "buyin": "$81",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Sundays",
    "name": "Sunday Freebuy w/ Add-ons / $1K GTD",
    "start": "3:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Thursdays",
    "name": "Thursday NLH $126 / $2K GTD",
    "start": "6:30pm",
    "buyin": "$126",
    "state": "Texas"
  },
  {
    "casino": "Amarillo Social Club",
    "day": "Wednesdays",
    "name": "Wednesday Freebuy w/ Add-ons / $500 GTD",
    "start": "6:30pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Aria Resort & Casino, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily No Limit Hold'em",
    "start": "1:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Daily (see notes)",
    "name": "$100 Turbo NLHE",
    "start": "10am",
    "buyin": "$100",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Fridays, Saturdays",
    "name": "$200 NLHE",
    "start": "7:00pm",
    "buyin": "$200",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Fridays, Saturdays",
    "name": "$300 Deep Stack NLHE",
    "start": "12pm",
    "buyin": "$300",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Mondays, Tuesdays, Wednesdays",
    "name": "$125 NLHE",
    "start": "12pm",
    "buyin": "$125",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Mondays, Tuesdays, Wednesdays",
    "name": "$60 Turbo NLHE",
    "start": "7pm",
    "buyin": "$60",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Sundays",
    "name": "$200 55K Stack NLHE",
    "start": "12pm",
    "buyin": "$200",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Sundays",
    "name": "$200 55K Stack NLHE",
    "start": "5pm",
    "buyin": "$200",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Sundays",
    "name": "No-Limit Hold'em Turbo",
    "start": "8:00pm",
    "buyin": "$100",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Thursdays",
    "name": "$200 NLHE",
    "start": "12pm",
    "buyin": "$200",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Thursdays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$125",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Black Hawk",
    "day": "Thursdays, Fridays, Saturdays",
    "name": "No-Limit Hold'em Night Owl Turbo",
    "start": "10:00pm",
    "buyin": "$100",
    "state": "Colorado"
  },
  {
    "casino": "Bally's Twin River Lincoln",
    "day": "Fridays",
    "name": "NLH",
    "start": "6:20pm",
    "buyin": "$145",
    "state": "Rhode Island"
  },
  {
    "casino": "Bally's Twin River Lincoln",
    "day": "Sundays",
    "name": "NLH",
    "start": "11:20am",
    "buyin": "$295",
    "state": "Rhode Island"
  },
  {
    "casino": "Bay 101",
    "day": "Fridays",
    "name": "Friday OneDay1K Satellite Turbo",
    "start": "8:30am",
    "buyin": "$200 ($160+$15+$25)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Mondays",
    "name": "Daily NLH Mystery Bounty",
    "start": "9:15am",
    "buyin": "$250 ($155+$50+$15+$25+$5)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Saturdays",
    "name": "Saturday OneDay $1K",
    "start": "8:30am",
    "buyin": "$1000 ($900+$50+$45+$5)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Sundays",
    "name": "Daily NLH",
    "start": "9:15am",
    "buyin": "$200 ($155+$15+$25+$5)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Thursdays",
    "name": "Daily NLH",
    "start": "9:15am",
    "buyin": "$200 ($155+$15+$25+$5)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Tuesdays",
    "name": "Daily NLH",
    "start": "9:15am",
    "buyin": "$200 ($155+$15+$25+$5)",
    "state": "California"
  },
  {
    "casino": "Bay 101",
    "day": "Wednesdays",
    "name": "Daily NLH",
    "start": "9:15am",
    "buyin": "$200 ($155+$15+$25+$5)",
    "state": "California"
  },
  {
    "casino": "Bear River Casino Hotel",
    "day": "Fridays, Saturdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Bear River Casino Hotel",
    "day": "Sundays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Bear River Casino Hotel",
    "day": "Wednesdays",
    "name": "Green Chip Bounty",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Beau Rivage Casino & Resort",
    "day": "Fridays, Sundays",
    "name": "NLH $5K GTD",
    "start": "12:15pm",
    "buyin": "$150",
    "state": "Mississippi"
  },
  {
    "casino": "Beau Rivage Casino & Resort",
    "day": "Mondays, Wednesdays",
    "name": "NLH Turbo",
    "start": "12:15pm",
    "buyin": "$100",
    "state": "Mississippi"
  },
  {
    "casino": "Beau Rivage Casino & Resort",
    "day": "Saturdays",
    "name": "NLH $10K GTD",
    "start": "12:15pm",
    "buyin": "$250",
    "state": "Mississippi"
  },
  {
    "casino": "Beau Rivage Casino & Resort",
    "day": "Tuesdays, Thursdays",
    "name": "NLH Green Chip Bounty",
    "start": "12:15pm",
    "buyin": "$140",
    "state": "Mississippi"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$150 NLH $2K GTD",
    "start": "12:00pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$150 NLH $2K GTD",
    "start": "5:00pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Saturdays",
    "name": "$200 NLH $3K GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Saturdays",
    "name": "$200 NLH $50 Bounty $3K GTD",
    "start": "5:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Sundays",
    "name": "$200 NLH $3K GTD",
    "start": "5:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Bellagio Hotel & Casino",
    "day": "Sundays",
    "name": "$200 NLH $50 Bounty $3K GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "bestbet Jacksonville",
    "day": "Fridays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "bestbet Jacksonville",
    "day": "Mondays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "bestbet Jacksonville",
    "day": "Sundays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "bestbet Jacksonville",
    "day": "Wednesdays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Fridays",
    "name": "Six Hour Ironman NLH",
    "start": "7:00pm",
    "buyin": "$160",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Mondays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Saturdays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Thursdays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Tuesdays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "bestbet St. Augustine",
    "day": "Wednesdays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Bestbet, Orange Park",
    "day": "Saturdays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Bestbet, Orange Park",
    "day": "Sundays",
    "name": "Weekly NLH",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Bestbet, Orange Park",
    "day": "Thursdays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Bestbet, Orange Park",
    "day": "Tuesdays",
    "name": "Weekly NLH",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Black Pearl Restaurant & Card Room",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$25 NLH",
    "start": "10:00am",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Black Pearl Restaurant & Card Room",
    "day": "Saturdays, Sundays",
    "name": "$50 NLH",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Black Pearl Restaurant & Card Room",
    "day": "Wednesdays, Sundays",
    "name": "$30 NLH",
    "start": "6:00pm",
    "buyin": "$30",
    "state": "Washington"
  },
  {
    "casino": "Boomtown Casino & Hotel, New Orleans",
    "day": "Thursdays",
    "name": "Thursday Night NLH $75",
    "start": "7:00pm",
    "buyin": "$75",
    "state": "Louisiana"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Mondays",
    "name": "Monday Night Madness",
    "start": "6:15pm",
    "buyin": "$130",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Mondays",
    "name": "Monster Stack Monday",
    "start": "11:15am",
    "buyin": "$180",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Sundays",
    "name": "Deep Stack Second Chance Survivor",
    "start": "2:15pm",
    "buyin": "$250",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Sundays",
    "name": "Early Bird Survivor Bankroll Builder",
    "start": "10:15am",
    "buyin": "$180",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Tuesdays",
    "name": "Big Stack Double Green Chip Bounty",
    "start": "11:15am",
    "buyin": "$190",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Tuesdays",
    "name": "Deep Stack Triple Blue Chip Bounty Turbo",
    "start": "6:15pm",
    "buyin": "$140",
    "state": "New Jersey"
  },
  {
    "casino": "Borgata Hotel Casino & Spa",
    "day": "Wednesdays",
    "name": "Deep Stack 30/30",
    "start": "11:15am",
    "buyin": "$250",
    "state": "New Jersey"
  },
  {
    "casino": "Broadway Grill & Pizzeria",
    "day": "Saturdays, Sundays",
    "name": "$40 NL Holdem",
    "start": "11:00am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Buzz Inn Steakhouse East Wenatchee",
    "day": "Fridays",
    "name": "$60 NL Holdem",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Buzz Inn Steakhouse East Wenatchee",
    "day": "Mondays, Thursdays",
    "name": "Freeroll NL Holdem",
    "start": "6:00pm",
    "buyin": "Free",
    "state": "Washington"
  },
  {
    "casino": "Buzz Inn Steakhouse East Wenatchee",
    "day": "Sundays",
    "name": "$100 NLH w/Add-On",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Buzz Inn Steakhouse East Wenatchee",
    "day": "Tuesdays",
    "name": "$55 NLH Deepstack",
    "start": "6:00pm",
    "buyin": "$55",
    "state": "Washington"
  },
  {
    "casino": "Buzz Inn Steakhouse East Wenatchee",
    "day": "Wednesdays",
    "name": "$50 NL Holdem",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Caesars Palace, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "10:00am",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Caesars Palace, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "2:00pm",
    "buyin": "$160",
    "state": "Nevada"
  },
  {
    "casino": "Caesars Palace, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Caesars Palace, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "9:00pm",
    "buyin": "$160",
    "state": "Nevada"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Fridays",
    "name": "Monster Stack Turbo NLH",
    "start": "11:15am",
    "buyin": "$250",
    "state": "Virginia"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Mondays, Tuesdays, Wednesdays, Sundays",
    "name": "Deep Stack Turbo NLH",
    "start": "7:15pm",
    "buyin": "$250",
    "state": "Virginia"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "NLH",
    "start": "11:15am",
    "buyin": "$200",
    "state": "Virginia"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Saturdays",
    "name": "Titan Stack",
    "start": "11:15am",
    "buyin": "$450",
    "state": "Virginia"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Sundays",
    "name": "Seniors NLH (50+)",
    "start": "11:15am",
    "buyin": "$300",
    "state": "Virginia"
  },
  {
    "casino": "Caesars Virginia",
    "day": "Thursdays",
    "name": "PLO",
    "start": "7:15pm",
    "buyin": "$350",
    "state": "Virginia"
  },
  {
    "casino": "Canterbury Park",
    "day": "2nd Mondays",
    "name": "$160 Pot Limit Omaha",
    "start": "6:30pm",
    "buyin": "$160",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "2nd Saturdays",
    "name": "$350 Deep Stack NLH",
    "start": "10:30am",
    "buyin": "$350",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Fridays",
    "name": "$100 NLH",
    "start": "5:00pm",
    "buyin": "$100",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Fridays",
    "name": "$150 Double Green Chip Bounty NLH",
    "start": "10:30am",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Mondays",
    "name": "$100 NLH",
    "start": "10:30am",
    "buyin": "$100",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Mondays",
    "name": "$150 Double Green Chip Bounty NLH",
    "start": "6:30pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Saturdays",
    "name": "$150 Super Stack NLH",
    "start": "5:00pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Saturdays",
    "name": "$250 Deep Stack NLH",
    "start": "10:30am",
    "buyin": "$250",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Sundays",
    "name": "$100 NLH",
    "start": "6:30pm",
    "buyin": "$100",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Sundays",
    "name": "$150 Deep Stack NLH",
    "start": "10:30am",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Thursdays",
    "name": "$100 NLH",
    "start": "10:30am",
    "buyin": "$100",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Thursdays",
    "name": "$150 Super Stack NLH",
    "start": "6:30pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Tuesdays",
    "name": "$150 Super Stack NLH",
    "start": "10:30am",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Tuesdays",
    "name": "$200 NLH $10K GTD",
    "start": "6:30pm",
    "buyin": "$200",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Wednesdays",
    "name": "$250 Double Stack NLH",
    "start": "6:30pm",
    "buyin": "$250",
    "state": "Minnesota"
  },
  {
    "casino": "Canterbury Park",
    "day": "Wednesdays",
    "name": "$75 NLH",
    "start": "10:30am",
    "buyin": "$75",
    "state": "Minnesota"
  },
  {
    "casino": "Capitol Casino",
    "day": "Mondays, Fridays",
    "name": "Daily NLH",
    "start": "10:10am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Capitol Casino",
    "day": "Saturdays",
    "name": "Saturday Deep Stack $100",
    "start": "10:10am",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Capitol Casino",
    "day": "Sundays",
    "name": "$3,000 Guaranteed",
    "start": "10:10am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Capitol Casino",
    "day": "Tuesdays, Wednesdays, Thursdays",
    "name": "Daily NLH",
    "start": "10:10am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Caribbean Cardroom",
    "day": "Friday",
    "name": "Friday NLH",
    "start": "2:00pm",
    "buyin": "$130",
    "state": "Washington"
  },
  {
    "casino": "Caribbean Cardroom",
    "day": "Tuesday, Wednesday, Thursday, Saturday, Sunday",
    "name": "Daily NLH",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Casino 99",
    "day": "Mondays, Wednesdays, Thursdays, Saturdays",
    "name": "$35 NL Holdem",
    "start": "10:00am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Casino 99",
    "day": "Sundays",
    "name": "$45 NL Holdem",
    "start": "5:00pm",
    "buyin": "$45",
    "state": "California"
  },
  {
    "casino": "Casino 99",
    "day": "Tuesdays, Fridays",
    "name": "$35 NL Holdem Rebuy",
    "start": "10:00am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Fridays",
    "name": "$150 NLH",
    "start": "12:00pm",
    "buyin": "$150",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Mondays",
    "name": "$150 Green Chip Bounty",
    "start": "2:00pm",
    "buyin": "$150",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Saturdays",
    "name": "$100 NLH",
    "start": "10:00am",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Sundays, Mondays, Tuesdays, Thursdays",
    "name": "$50 NLH",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Tuesdays, Thursdays",
    "name": "$100 Green Chip Bounty",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Kirkland",
    "day": "Wednesdays",
    "name": "$50 Beat the Boss Bounty",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Yakima",
    "day": "Mondays, Wednesdays, Fridays",
    "name": "MWF Evening NLH $65",
    "start": "7:00pm",
    "buyin": "$65",
    "state": "Washington"
  },
  {
    "casino": "Casino Caribbean Yakima",
    "day": "Saturdays, Sundays",
    "name": "Weekend Noon NLH $120 ($2K GTD)",
    "start": "12:00pm",
    "buyin": "$120",
    "state": "Washington"
  },
  {
    "casino": "Casino Club",
    "day": "Saturdays (third each month)",
    "name": "Monthly NLH $150 (3rd Saturday)",
    "start": "4:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Casino Club",
    "day": "Sundays",
    "name": "Sunday NLH $70",
    "start": "4:00pm",
    "buyin": "$70",
    "state": "California"
  },
  {
    "casino": "Casino Club",
    "day": "Thursdays",
    "name": "Thursday Deepstack NLH $80",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Casino Club",
    "day": "Tuesdays",
    "name": "Tuesday NLH $80",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Casino del Sol",
    "day": "Mondays",
    "name": "Monday Reload Madness NLH",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Arizona"
  },
  {
    "casino": "Casino del Sol",
    "day": "Sundays",
    "name": "Sunday Bounty NLH",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Arizona"
  },
  {
    "casino": "Casino del Sol",
    "day": "Tuesdays, Wednesdays",
    "name": "Weekday Turbo NLH",
    "start": "1:00pm",
    "buyin": "$40",
    "state": "Arizona"
  },
  {
    "casino": "Central Coast Casino",
    "day": "1st Wednesday",
    "name": "1st Wednesday Monthly $100 NLH",
    "start": "5:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Central Coast Casino",
    "day": "Fridays",
    "name": "$100/$60 NLH Tournament",
    "start": "4:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Central Coast Casino",
    "day": "Mondays",
    "name": "$20/$20 NLH Tournament",
    "start": "4:00pm",
    "buyin": "$20",
    "state": "California"
  },
  {
    "casino": "Central Coast Casino",
    "day": "Sundays",
    "name": "Survival Sunday $100/$20 Freezeout",
    "start": "10:00am",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Champions Club Texas",
    "day": "Fridays",
    "name": "15K GTD Friday Unchained NLH",
    "start": "5:30pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "Champions Club Texas",
    "day": "Mondays",
    "name": "4K Monday Night 40/40/40 NLH",
    "start": "5:30pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Champions Club Texas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "1K GTD 40/40/40 Daily NLH",
    "start": "1:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Champions Club Texas",
    "day": "Thursdays",
    "name": "2K GTD Turbo NLH w/ Friday Entry",
    "start": "5:30pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Champions Club Texas",
    "day": "Wednesdays",
    "name": "5K Midweek PLO",
    "start": "5:30pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "Champions Social Club",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$70 NL Holdem",
    "start": "10:30am",
    "buyin": "$70",
    "state": "Texas"
  },
  {
    "casino": "Clearwater Saloon & Casino",
    "day": "Mondays, Tuesdays",
    "name": "Afternoon Freeroll",
    "start": "1:00pm",
    "buyin": "Free",
    "state": "Washington"
  },
  {
    "casino": "Clearwater Saloon & Casino",
    "day": "Mondays, Tuesdays, Thursdays, Fridays",
    "name": "Evening Freeroll",
    "start": "6:00pm",
    "buyin": "Free",
    "state": "Washington"
  },
  {
    "casino": "Clearwater Saloon & Casino",
    "day": "Wednesdays",
    "name": "$27 Satellite to Monthly $10K",
    "start": "1:00pm",
    "buyin": "$27",
    "state": "Washington"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Fridays",
    "name": "Friday Night",
    "start": "6:30pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Fridays",
    "name": "Omaha Hi-Lo",
    "start": "11:00am",
    "buyin": "$70",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Mondays",
    "name": "No-Limit Hold'em",
    "start": "6:30pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Sundays",
    "name": "Sunday Mega Stack",
    "start": "12:00pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Thursdays",
    "name": "Crazy Pineapple",
    "start": "11:00am",
    "buyin": "$45",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Tuesdays",
    "name": "Deuces Wild",
    "start": "11:00am",
    "buyin": "$45",
    "state": "Florida"
  },
  {
    "casino": "Club 52 Poker at Melbourne Greyhound Park",
    "day": "Wednesdays",
    "name": "Turbo",
    "start": "6:30pm",
    "buyin": "$70",
    "state": "Florida"
  },
  {
    "casino": "Club One Casino",
    "day": "Fridays",
    "name": "Friday Road to Riches $5,000 GTD",
    "start": "10:15am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Mondays",
    "name": "Monday Madness $3,000 GTD",
    "start": "10:15am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Saturdays",
    "name": "Saturday Morning Omaha 8+ $2,500 GTD",
    "start": "10:15am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Sundays",
    "name": "Sunday High Roller $10,000 GTD",
    "start": "12:15pm",
    "buyin": "$120",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Thursdays",
    "name": "Thursday Night $3,000 GTD",
    "start": "6:15pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Tuesdays",
    "name": "Tuesday Nights W/Ted $6,000 GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Club One Casino",
    "day": "Wednesdays",
    "name": "Live Action Wednesdays $500",
    "start": "10:15am",
    "buyin": "$0",
    "state": "California"
  },
  {
    "casino": "Club San Rafael",
    "day": "Mondays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Club San Rafael",
    "day": "Saturdays",
    "name": "NLH Bounty",
    "start": "3:00pm",
    "buyin": "$300",
    "state": "California"
  },
  {
    "casino": "Club San Rafael",
    "day": "Sundays",
    "name": "NLH",
    "start": "4:30pm",
    "buyin": "$220",
    "state": "California"
  },
  {
    "casino": "Commerce Casino",
    "day": "Fridays",
    "name": "Friday NLHE $5,000 GTD",
    "start": "4:00pm",
    "buyin": "$140",
    "state": "California"
  },
  {
    "casino": "Commerce Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "Daily NLHE $5,000 GTD",
    "start": "4:00pm",
    "buyin": "$140",
    "state": "California"
  },
  {
    "casino": "Commerce Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Daily NLHE $2,000 GTD",
    "start": "11:00am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Commerce Casino",
    "day": "Saturdays",
    "name": "Saturday NLHE $25,000 GTD",
    "start": "12:00pm",
    "buyin": "$250",
    "state": "California"
  },
  {
    "casino": "Commerce Casino",
    "day": "Sundays",
    "name": "Sunday NLHE $15,000 GTD",
    "start": "12:00pm",
    "buyin": "$250",
    "state": "California"
  },
  {
    "casino": "Crazy Moose Casino Pasco",
    "day": "Mondays, Wednesdays, Thursdays, Fridays, Saturdays",
    "name": "$40 NLH",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Crazy Moose Casino Pasco",
    "day": "Saturdays",
    "name": "$120 Saturday NLH",
    "start": "10:00am",
    "buyin": "$120",
    "state": "Washington"
  },
  {
    "casino": "Crazy Moose Casino Pasco",
    "day": "Sundays, Mondays, Wednesdays, Thursdays, Fridays",
    "name": "$40 NLH",
    "start": "10:00am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Crazy Moose Casino Pasco",
    "day": "Tuesdays",
    "name": "$40 Tuesday Tahoe",
    "start": "10:00am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Crazy Moose Casino Pasco",
    "day": "Tuesdays",
    "name": "$40 Tuesday Tahoe",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Fridays",
    "name": "$130 GAPT Seniors 50+ NLH",
    "start": "12:10pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Fridays",
    "name": "$165 GAPT Friday Night Lights NLH",
    "start": "7:10pm",
    "buyin": "$165",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Mondays",
    "name": "$80 Double Board Bomb Pot NLH",
    "start": "12:10pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Saturdays",
    "name": "$100 Double Board Bomb Pot",
    "start": "7:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Saturdays",
    "name": "$130 Deep Stack NLH",
    "start": "12:10pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Sundays",
    "name": "$165 GAPT Road To The Championship NLH",
    "start": "12:10pm",
    "buyin": "$165",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Thursdays",
    "name": "$80 Crazy Pineapple",
    "start": "12:10pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Tuesdays",
    "name": "$100 Green Chip Bounty NLH",
    "start": "12:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Daytona Beach Kennel Club & Poker Room, Williamson Blvd",
    "day": "Wednesdays",
    "name": "$100 Double Stack Turbo NLH",
    "start": "7:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Fridays",
    "name": "$120 NLH $12K GTE No Rake",
    "start": "6:30pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Fridays",
    "name": "$95 NLH $2K GTE $25 KO",
    "start": "11:00am",
    "buyin": "$95",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Mondays",
    "name": "$60 NLH $1.2K GTE",
    "start": "11:00am",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Mondays",
    "name": "$70 NLH $6.5K GTE",
    "start": "6:30pm",
    "buyin": "$70",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Saturdays",
    "name": "$60 NLH $3.5K GTE",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Saturdays",
    "name": "$80 Deuces Wild $2K GTE $30 KO",
    "start": "6:30pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Sundays",
    "name": "$60 NLH $3.5K GTE",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Thursdays",
    "name": "$120 NLH $8K GTE $25 KO",
    "start": "6:30pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Thursdays",
    "name": "$60 NLH $1.2K GTE",
    "start": "11:00am",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Tuesdays",
    "name": "$180 NLH $16K GTE",
    "start": "6:30pm",
    "buyin": "$180",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Tuesdays",
    "name": "$60 NLH $1.2K GTE",
    "start": "11:00am",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Wednesdays",
    "name": "$55 NLH $5K GTE",
    "start": "6:30pm",
    "buyin": "$55",
    "state": "Florida"
  },
  {
    "casino": "Derby Lane Poker Room",
    "day": "Wednesdays",
    "name": "$60 NLH $1.2K GTE",
    "start": "11:00am",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Desert Diamond Casino & Hotel, Tucson",
    "day": "Sundays, Wednesdays",
    "name": "Bounty Bash",
    "start": "Sundays 1pm; Wednesdays 7pm",
    "buyin": "$60",
    "state": "Arizona"
  },
  {
    "casino": "Desert Diamond Casino & Hotel, Tucson",
    "day": "Tuesdays, Thursdays",
    "name": "High Noon Poker Tournament",
    "start": "12pm",
    "buyin": "$40",
    "state": "Arizona"
  },
  {
    "casino": "Desert Diamond Casino, West Valley",
    "day": "Fridays",
    "name": "Friday Morning NLHE",
    "start": "10am",
    "buyin": "$130",
    "state": "Arizona"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Fridays",
    "name": "$3K GTD Thaw & Chill",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Mondays",
    "name": "$2.5K GTD Freeze Out",
    "start": "7:00pm",
    "buyin": "$75",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Saturdays",
    "name": "$5K GTD Re-Entry",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Sundays",
    "name": "$3K GTD Freeroll",
    "start": "2:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Thursdays",
    "name": "$3K GTD Freeroll",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Tuesdays",
    "name": "$2.5K GTD R.O.E. Rebuy Frenzy",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Doghouse Poker Club",
    "day": "Wednesdays",
    "name": "$2.5K GTD Freeze Out",
    "start": "7:00pm",
    "buyin": "$75",
    "state": "Texas"
  },
  {
    "casino": "Ebro Poker Room",
    "day": "Sundays",
    "name": "$480 Deep Stack NLH $10K GTD",
    "start": "2:00pm",
    "buyin": "$480",
    "state": "Florida"
  },
  {
    "casino": "Ebro Poker Room",
    "day": "Thursdays",
    "name": "$260 NLH $7K GTD",
    "start": "6:00pm",
    "buyin": "$260",
    "state": "Florida"
  },
  {
    "casino": "Ebro Poker Room",
    "day": "Tuesdays",
    "name": "$90 NLH $2K GTD",
    "start": "6:00pm",
    "buyin": "$90",
    "state": "Florida"
  },
  {
    "casino": "Ebro Poker Room",
    "day": "Wednesdays",
    "name": "$150 NLH $4K GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "El Dorado Hills Casino",
    "day": "Saturdays",
    "name": "Deep Stack Saturdays $4K GTD",
    "start": "3:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "El Dorado Hills Casino",
    "day": "Sundays",
    "name": "Super Sunday Bankroll Builder",
    "start": "3:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "FireKeepers",
    "day": "Fridays",
    "name": "$125 Green Chip Bounty NLHE",
    "start": "6:15pm",
    "buyin": "$125",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Fridays",
    "name": "$65 NLHE",
    "start": "12:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Fridays",
    "name": "$85 Triple Nickel Bounty",
    "start": "8:15pm",
    "buyin": "$85",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Mondays, Tuesdays, Wednesdays",
    "name": "$65 NLHE",
    "start": "12:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Mondays, Tuesdays, Wednesdays",
    "name": "$65 NLHE",
    "start": "6:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Saturdays",
    "name": "$275 MSPT Milestone",
    "start": "6:15pm",
    "buyin": "$275",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Saturdays",
    "name": "$70 Bomb Pot PLO",
    "start": "8:15pm",
    "buyin": "$70",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Saturdays",
    "name": "$70 MSPT Milestone",
    "start": "12:15pm",
    "buyin": "$70",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Sundays",
    "name": "$100 Mega Stack NLHE",
    "start": "4:15pm",
    "buyin": "$100",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Sundays",
    "name": "$200 NLHE",
    "start": "12:15pm",
    "buyin": "$200",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Sundays",
    "name": "$65 Pineapple",
    "start": "6:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Thursdays",
    "name": "$65 NLHE",
    "start": "12:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "FireKeepers",
    "day": "Thursdays",
    "name": "$65 PLO",
    "start": "6:15pm",
    "buyin": "$65",
    "state": "Michigan"
  },
  {
    "casino": "Fortune Casino La Center",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
    "name": "$70 NLH",
    "start": "10:00am",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "Fortune Casino La Center",
    "day": "Sundays",
    "name": "$225 Sunday NLH",
    "start": "10:00am",
    "buyin": "$225",
    "state": "Washington"
  },
  {
    "casino": "Fortune Casino Lacey",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH $60",
    "start": "10:00am",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Fortune Poker Renton",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$60 NLH",
    "start": "8:30am",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Fortune Poker Renton",
    "day": "Saturdays, Sundays",
    "name": "$60 NLH",
    "start": "8:30am",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Four Winds Casino South Bend",
    "day": "Fridays",
    "name": "NLHE",
    "start": "1:00pm",
    "buyin": "$125",
    "state": "Indiana"
  },
  {
    "casino": "Four Winds Casino South Bend",
    "day": "Sundays",
    "name": "NLHE",
    "start": "2:00pm",
    "buyin": "$100",
    "state": "Indiana"
  },
  {
    "casino": "Four Winds Casino South Bend",
    "day": "Sundays (first of month)",
    "name": "NLHE First Sunday",
    "start": "2:00pm",
    "buyin": "$250",
    "state": "Indiana"
  },
  {
    "casino": "Four Winds Casino South Bend",
    "day": "Wednesdays",
    "name": "NLHE",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Indiana"
  },
  {
    "casino": "Foxwoods Casino & Resort",
    "day": "Mondays",
    "name": "$155 NLH",
    "start": "11:10am",
    "buyin": "$155",
    "state": "Connecticut"
  },
  {
    "casino": "Foxwoods Casino & Resort",
    "day": "Sundays",
    "name": "$295 NLH",
    "start": "10:10am",
    "buyin": "$295",
    "state": "Connecticut"
  },
  {
    "casino": "Foxwoods Casino & Resort",
    "day": "Thursdays",
    "name": "$195 NLH",
    "start": "5:10pm",
    "buyin": "$195",
    "state": "Connecticut"
  },
  {
    "casino": "Foxwoods Casino & Resort",
    "day": "Tuesdays",
    "name": "$135 NLH",
    "start": "10:10am",
    "buyin": "$135",
    "state": "Connecticut"
  },
  {
    "casino": "Foxwoods Casino & Resort",
    "day": "Tuesdays",
    "name": "$135 NLH",
    "start": "5:10pm",
    "buyin": "$135",
    "state": "Connecticut"
  },
  {
    "casino": "Garlic City Casino & Restaurant",
    "day": "Sundays",
    "name": "Sunday NLH $90",
    "start": "11:00am",
    "buyin": "$90",
    "state": "California"
  },
  {
    "casino": "Garlic City Casino & Restaurant",
    "day": "Wednesdays",
    "name": "Wednesday NLH $50",
    "start": "11:00am",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Golden West Casino",
    "day": "Saturdays",
    "name": "$100 Saturday NLH",
    "start": "12:15pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Golden West Casino",
    "day": "Wednesdays",
    "name": "$80 Wednesday NLH",
    "start": "6:15pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Grand Victoria Casino",
    "day": "Fridays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$250",
    "state": "Illinois"
  },
  {
    "casino": "Grand Victoria Casino",
    "day": "Sundays",
    "name": "Deep Stack NLH",
    "start": "12:00pm",
    "buyin": "$300",
    "state": "Illinois"
  },
  {
    "casino": "Grand Victoria Casino",
    "day": "Tuesdays",
    "name": "NLH",
    "start": "5:00pm",
    "buyin": "$150",
    "state": "Illinois"
  },
  {
    "casino": "Graton Resort & Casino",
    "day": "Mondays, Wednesdays, Fridays",
    "name": "Daily Events $135",
    "start": "10:00am",
    "buyin": "$135",
    "state": "California"
  },
  {
    "casino": "Graton Resort & Casino",
    "day": "Sundays",
    "name": "Sunday Weekly $250 Black Chip Bounty",
    "start": "10:00am",
    "buyin": "$250",
    "state": "California"
  },
  {
    "casino": "Graton Resort & Casino",
    "day": "Thursdays",
    "name": "Green Chip Bounty $200",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "California"
  },
  {
    "casino": "Graton Resort & Casino",
    "day": "Thursdays",
    "name": "Thursday Weekly $65 Turbo",
    "start": "10:00am",
    "buyin": "$65",
    "state": "California"
  },
  {
    "casino": "Graton Resort & Casino",
    "day": "Tuesdays",
    "name": "Daily Events $135",
    "start": "6:00pm",
    "buyin": "$135",
    "state": "California"
  },
  {
    "casino": "Green Valley Ranch Resort, Casino & Spa",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "$99 NL Hold'em",
    "start": "12:00pm",
    "buyin": "$99",
    "state": "Nevada"
  },
  {
    "casino": "Gun Lake Casino",
    "day": "Mondays, Wednesdays",
    "name": "NLH",
    "start": "7:15pm",
    "buyin": "$60",
    "state": "Michigan"
  },
  {
    "casino": "Gun Lake Casino",
    "day": "Saturdays",
    "name": "Green Chip Bounty",
    "start": "12:15pm",
    "buyin": "$125",
    "state": "Michigan"
  },
  {
    "casino": "Hard Rock Casino Rockford",
    "day": "Mondays",
    "name": "Money Monday NLHE $3,000 GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Illinois"
  },
  {
    "casino": "Hard Rock Casino Rockford",
    "day": "Thursdays",
    "name": "Thursday Bounty NLHE",
    "start": "6:00pm",
    "buyin": "$125",
    "state": "Illinois"
  },
  {
    "casino": "Hard Rock Casino Rockford",
    "day": "Wednesdays",
    "name": "Wild Wednesday NLHE $1,500 GTD",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Illinois"
  },
  {
    "casino": "Harrah's Pompano Beach",
    "day": "Tuesdays",
    "name": "$200 NL Holdem",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Fridays",
    "name": "Deep Stack",
    "start": "8:00pm",
    "buyin": "$250",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Mondays, Tuesdays, Wednesdays, Saturdays, Sundays",
    "name": "NLH",
    "start": "7:00pm",
    "buyin": "$140",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "NLH",
    "start": "10:00pm",
    "buyin": "$80",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Saturdays",
    "name": "Deep Stack",
    "start": "12:00pm",
    "buyin": "$250",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Sundays",
    "name": "Deep Stack",
    "start": "10:00am",
    "buyin": "$250",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Sundays",
    "name": "NLH",
    "start": "4:00pm",
    "buyin": "$140",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino & Resort, Cherokee",
    "day": "Thursdays",
    "name": "Mystery Bounty",
    "start": "7:00pm",
    "buyin": "$250",
    "state": "North Carolina"
  },
  {
    "casino": "Harrahs Casino, New Orleans",
    "day": "Mondays",
    "name": "No Limit Hold'em",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Louisiana"
  },
  {
    "casino": "Harrahs Casino, New Orleans",
    "day": "Saturdays",
    "name": "Saturday Mini Gladiator",
    "start": "11:15am",
    "buyin": "$300",
    "state": "Louisiana"
  },
  {
    "casino": "Harrahs Casino, New Orleans",
    "day": "Wednesdays",
    "name": "No Limit Hold'em Bounty",
    "start": "6:15pm",
    "buyin": "$200",
    "state": "Louisiana"
  },
  {
    "casino": "Hollywood Casino @ Kansas Speedway",
    "day": "Mondays, Tuesdays, Thursdays",
    "name": "Deep Stack NLH",
    "start": "10:45am",
    "buyin": "$150",
    "state": "Kansas"
  },
  {
    "casino": "Hollywood Casino @ Kansas Speedway",
    "day": "Sundays",
    "name": "Monster Stack NLH",
    "start": "10:45am",
    "buyin": "$350",
    "state": "Kansas"
  },
  {
    "casino": "Hollywood Casino @ Kansas Speedway",
    "day": "Tuesdays, Thursdays",
    "name": "Deep Stack Green Chip Bounty NLH",
    "start": "6:45pm",
    "buyin": "$150",
    "state": "Kansas"
  },
  {
    "casino": "Hollywood Casino @ Kansas Speedway",
    "day": "Wednesdays",
    "name": "Freezeout NLH",
    "start": "6:45pm",
    "buyin": "$200",
    "state": "Kansas"
  },
  {
    "casino": "Hollywood Casino, Columbus",
    "day": "Fridays",
    "name": "Top Tier NLH",
    "start": "7:15pm",
    "buyin": "$120",
    "state": "Ohio"
  },
  {
    "casino": "Hollywood Casino, Columbus",
    "day": "Mondays, Thursdays",
    "name": "Hollywood 2K",
    "start": "7:15pm",
    "buyin": "$100",
    "state": "Ohio"
  },
  {
    "casino": "Hollywood Casino, Columbus",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "NLH Turbo",
    "start": "12:15pm",
    "buyin": "$80",
    "state": "Ohio"
  },
  {
    "casino": "Hollywood Casino, Columbus",
    "day": "Sundays",
    "name": "Sunday Super 7K",
    "start": "12:15pm",
    "buyin": "$160",
    "state": "Ohio"
  },
  {
    "casino": "Hollywood Casino, Columbus",
    "day": "Wednesdays",
    "name": "Top Tier NLH",
    "start": "7:15pm",
    "buyin": "$200",
    "state": "Ohio"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Fridays",
    "name": "TGIF + Bounty",
    "start": "10:00am",
    "buyin": "$200–$300",
    "state": "California"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Saturdays",
    "name": "$8K Bankroll Builder",
    "start": "10:00am",
    "buyin": "$100+$100",
    "state": "California"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Thursdays",
    "name": "$12K Thursdays",
    "start": "3:00pm",
    "buyin": "$160+$100",
    "state": "California"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Tuesdays",
    "name": "$12K Tuesdays",
    "start": "3:00pm",
    "buyin": "$160+$100",
    "state": "California"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Wednesdays",
    "name": "$10K NLHE + $50 Bounty",
    "start": "6:00pm",
    "buyin": "$250",
    "state": "California"
  },
  {
    "casino": "Hollywood Park Casino",
    "day": "Wednesdays",
    "name": "Big O",
    "start": "11:00am",
    "buyin": "$125",
    "state": "California"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Fridays",
    "name": "No Limit Hold'em Bounty",
    "start": "7:00pm",
    "buyin": "$45",
    "state": "Arizona"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Saturdays",
    "name": "No Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$30",
    "state": "Arizona"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Sundays",
    "name": "Crazy Pineapple",
    "start": "7:00pm",
    "buyin": "$30",
    "state": "Arizona"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Thursdays",
    "name": "Omaha 8/B",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Arizona"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Tuesdays",
    "name": "Mix",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Arizona"
  },
  {
    "casino": "Hon-Dah Casino",
    "day": "Wednesdays",
    "name": "No Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Arizona"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Mondays",
    "name": "NLH w/ Rebuy & Add-On",
    "start": "7:00pm",
    "buyin": "$85",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$90",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Saturdays",
    "name": "NLH Fat Stack",
    "start": "10:00am",
    "buyin": "$250",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Sundays",
    "name": "NLH",
    "start": "12:00pm",
    "buyin": "$150",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Thursdays",
    "name": "NLH w/ $25 Bounty",
    "start": "7:00pm",
    "buyin": "$125",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Tuesdays",
    "name": "NLH w/ Add-On",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Council Bluffs",
    "day": "Wednesdays",
    "name": "NLH",
    "start": "7:00pm",
    "buyin": "$120",
    "state": "Iowa"
  },
  {
    "casino": "Horseshoe Casino, Southern Indiana",
    "day": "Mondays",
    "name": "Final Table Jackpot NLHE $2,000 GTD",
    "start": "12:00pm",
    "buyin": "$80",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Casino, Southern Indiana",
    "day": "Sundays",
    "name": "Final Table Jackpot NLHE",
    "start": "3:00pm",
    "buyin": "$110",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Casino, Southern Indiana",
    "day": "Thursdays",
    "name": "Final Table Jackpot NLHE",
    "start": "12:00pm",
    "buyin": "$80",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Casino, Southern Indiana",
    "day": "Wednesdays",
    "name": "$25 Bounty NLHE $3,000 GTD",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Fridays",
    "name": "NLHE",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Fridays",
    "name": "NLHE",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Mondays",
    "name": "NLHE",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Thursdays",
    "name": "NLHE",
    "start": "11:00am",
    "buyin": "$85",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Thursdays",
    "name": "NLHE",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Tuesdays",
    "name": "NLHE",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Indianapolis",
    "day": "Wednesdays",
    "name": "Omaha 8 / Stud 8",
    "start": "3:00pm",
    "buyin": "$85",
    "state": "Indiana"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "9:00am",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "2:00pm",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "5:00pm",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "8:00pm",
    "buyin": "$160",
    "state": "Nevada"
  },
  {
    "casino": "Horseshoe Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "11:00pm",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Imperial Palace Casino Auburn",
    "day": "Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "$50 NL Holdem",
    "start": "4:00pm",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Jack Casino, Cleveland",
    "day": "Fridays",
    "name": "The Benjamin",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Ohio"
  },
  {
    "casino": "Jack Casino, Cleveland",
    "day": "Mondays",
    "name": "The Benjamin",
    "start": "12:15pm",
    "buyin": "$100",
    "state": "Ohio"
  },
  {
    "casino": "Jack Casino, Cleveland",
    "day": "Thursdays",
    "name": "Super Stack",
    "start": "3:15pm",
    "buyin": "$250",
    "state": "Ohio"
  },
  {
    "casino": "Jack Casino, Cleveland",
    "day": "Tuesdays",
    "name": "The Benjamin",
    "start": "12:15pm",
    "buyin": "$100",
    "state": "Ohio"
  },
  {
    "casino": "Jack Casino, Cleveland",
    "day": "Wednesdays",
    "name": "Stack Escalator",
    "start": "12:15pm",
    "buyin": "$150",
    "state": "Ohio"
  },
  {
    "casino": "Jackson Rancheria Casino",
    "day": "Saturdays",
    "name": "Saturday NLH $100 (Big Blind Ante)",
    "start": "3:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Jackson Rancheria Casino",
    "day": "Sundays",
    "name": "Sunday NLH $80",
    "start": "3:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Jackson Rancheria Casino",
    "day": "Thursdays",
    "name": "Thursday NLH $60",
    "start": "3:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Jamestown Saloon",
    "day": "Saturdays",
    "name": "$75 NL Holdem",
    "start": "10:30am",
    "buyin": "$75",
    "state": "Washington"
  },
  {
    "casino": "Jamestown Saloon",
    "day": "Sundays",
    "name": "$120 NL Holdem",
    "start": "10:30am",
    "buyin": "$120",
    "state": "Washington"
  },
  {
    "casino": "Jamestown Saloon",
    "day": "Tuesdays",
    "name": "$75 NL Holdem",
    "start": "6:30pm",
    "buyin": "$75",
    "state": "Washington"
  },
  {
    "casino": "Jamestown Saloon",
    "day": "Tuesdays, Fridays",
    "name": "$60 NL Holdem",
    "start": "10:30am",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Fridays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Mondays, Wednesdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Saturdays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Saturdays (1st, 3rd, 4th and 5th each month)",
    "name": "NLH",
    "start": "4:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Saturdays (2nd and 4th each month)",
    "name": "Helix Poker Series NLHE",
    "start": "4:00pm",
    "buyin": "$125",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Sundays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Sundays",
    "name": "NLH",
    "start": "4:00pm",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Jamul Casino Resort",
    "day": "Tuesdays, Thursdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Joker's Casino and Sports Bar",
    "day": "Fridays",
    "name": "NLH",
    "start": "1:00pm",
    "buyin": "$100",
    "state": "Washington"
  },
  {
    "casino": "Joker's Casino and Sports Bar",
    "day": "Mondays, Wednesdays, Thursdays",
    "name": "NLH",
    "start": "3:00pm",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Joker's Casino and Sports Bar",
    "day": "Sundays",
    "name": "NLH",
    "start": "1:00pm",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "Joker's Casino and Sports Bar",
    "day": "Tuesdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$70",
    "state": "Washington"
  },
  {
    "casino": "Kickapoo Lucky Eagle Casino & Hotel",
    "day": "Saturdays",
    "name": "Saturday NLH",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Kickapoo Lucky Eagle Casino & Hotel",
    "day": "Tuesdays, Thursdays",
    "name": "Super Days NLH",
    "start": "7:00pm",
    "buyin": "$35",
    "state": "Texas"
  },
  {
    "casino": "Lancer Lanes and Casino",
    "day": "Mondays",
    "name": "WSOP Satellite",
    "start": "6:30pm",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Fridays",
    "name": "Friday Night Grind",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Fridays",
    "name": "No-Limit Hold'em",
    "start": "1:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Mondays",
    "name": "NLH Unlimited Rebuy",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Mondays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Saturdays",
    "name": "Saturday Showdown",
    "start": "3:00pm",
    "buyin": "$200",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Sundays",
    "name": "Royal Sunday",
    "start": "3:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Thursdays",
    "name": "NLH Unlimited Rebuy",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Thursdays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Tuesdays",
    "name": "Big O",
    "start": "1:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Tuesdays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Wednesdays",
    "name": "NLH Unlimited Rebuy",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Larry Flynt's Lucky Lady Casino",
    "day": "Wednesdays",
    "name": "No-Limit Hold'em",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Fridays",
    "name": "$40 NLH",
    "start": "10:30am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Fridays",
    "name": "$75 NLH",
    "start": "7:00pm",
    "buyin": "$75",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Mondays, Wednesdays",
    "name": "$25 NLH",
    "start": "7:00pm",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Mondays, Wednesdays",
    "name": "$40 NLH",
    "start": "10:30am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Saturdays",
    "name": "$40 NLH",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Saturdays, Sundays",
    "name": "$50 NLH",
    "start": "1:00pm",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Sundays",
    "name": "$25 NLH",
    "start": "6:00pm",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Thursdays",
    "name": "$40 Industry Night",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Tuesdays",
    "name": "$40 Bounty",
    "start": "7:00pm",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Lilac Lanes & Casino",
    "day": "Tuesdays, Thursdays",
    "name": "$40 Bounty",
    "start": "10:30am",
    "buyin": "$40",
    "state": "Washington"
  },
  {
    "casino": "Little Creek Casino Resort",
    "day": "Fridays",
    "name": "$130 Friday NLH",
    "start": "7:00pm",
    "buyin": "$130",
    "state": "Washington"
  },
  {
    "casino": "Little Creek Casino Resort",
    "day": "Mondays",
    "name": "$25 Monday Turbo",
    "start": "7:00pm",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Little Creek Casino Resort",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "$45 Daily NLH",
    "start": "10:00am",
    "buyin": "$45",
    "state": "Washington"
  },
  {
    "casino": "Little Creek Casino Resort",
    "day": "Tuesdays",
    "name": "$25 Tuesday Turbo",
    "start": "7:00pm",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Little Creek Casino Resort",
    "day": "Wednesdays, Thursdays",
    "name": "$60 NLH",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Washington"
  },
  {
    "casino": "Livermore Casino",
    "day": "Sundays",
    "name": "Sunday Morning Showdown",
    "start": "10:00am",
    "buyin": "$130",
    "state": "California"
  },
  {
    "casino": "Livermore Casino",
    "day": "Wednesdays",
    "name": "Wednesday Hold'em",
    "start": "10:00am",
    "buyin": "$85",
    "state": "California"
  },
  {
    "casino": "Lone Butte Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Sundays",
    "name": "No Limit Hold'em",
    "start": "11:00am",
    "buyin": "$85",
    "state": "Arizona"
  },
  {
    "casino": "Lone Butte Casino",
    "day": "Saturdays",
    "name": "Monster Stack",
    "start": "10:00am",
    "buyin": "$400",
    "state": "Arizona"
  },
  {
    "casino": "Lone Butte Casino",
    "day": "Wednesdays, Thursdays",
    "name": "No Limit Hold'em",
    "start": "6:30pm",
    "buyin": "$85",
    "state": "Arizona"
  },
  {
    "casino": "Lucky Chances",
    "day": "Fridays, Saturdays",
    "name": "$240 NL Holdem",
    "start": "9:30am",
    "buyin": "$240",
    "state": "California"
  },
  {
    "casino": "Lucky Chances",
    "day": "Sundays",
    "name": "$300 NL Holdem",
    "start": "9:30am",
    "buyin": "$300",
    "state": "California"
  },
  {
    "casino": "Lucky Chances",
    "day": "Wednesdays, Thursdays",
    "name": "$165 NL Holdem",
    "start": "9:30am",
    "buyin": "$165",
    "state": "California"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Fridays",
    "name": "Friday 50/50 $4K GTD",
    "start": "6:00pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Mondays",
    "name": "Weekly PLO $1K GTD",
    "start": "6:45pm",
    "buyin": "$50",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Saturdays",
    "name": "Stratosphere Stack $4K GTD",
    "start": "6:45pm",
    "buyin": "$110",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Saturdays",
    "name": "Twin River Hold'em",
    "start": "2:00pm",
    "buyin": "$50",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Thursdays",
    "name": "99 Problems $9,999 GTD",
    "start": "6:45pm",
    "buyin": "$99",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Tuesdays",
    "name": "50/50 Tuesday $1K GTD",
    "start": "6:45pm",
    "buyin": "$55",
    "state": "Florida"
  },
  {
    "casino": "Lucky's Card Room (TGT Poker)",
    "day": "Wednesdays",
    "name": "Wednesday Mixed Games $1.5K GTD",
    "start": "11:30am",
    "buyin": "$160",
    "state": "Florida"
  },
  {
    "casino": "Mandalay Bay, Las Vegas",
    "day": "Mondays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Nevada"
  },
  {
    "casino": "Mandalay Bay, Las Vegas",
    "day": "Mondays, Wednesdays, Thursdays, Fridays, Sundays",
    "name": "Daily NLH",
    "start": "8:00pm",
    "buyin": "$60",
    "state": "Nevada"
  },
  {
    "casino": "Mandalay Bay, Las Vegas",
    "day": "Saturdays",
    "name": "Saturday Night NLH",
    "start": "8:00pm",
    "buyin": "$100",
    "state": "Nevada"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Fridays",
    "name": "DeepStacks",
    "start": "11:15am",
    "buyin": "$220",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Fridays",
    "name": "The Weekend Warm-Up",
    "start": "7:15pm",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Mondays",
    "name": "FatStacks w/ $25 Bounty",
    "start": "11:15am",
    "buyin": "$120",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Mondays",
    "name": "QuadStacks",
    "start": "7:15pm",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Saturdays",
    "name": "Saturday Nightly NLH",
    "start": "5:15pm",
    "buyin": "$200",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Sundays",
    "name": "Bankroll Builder / QuadStacks (day)",
    "start": "11:15am",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Sundays",
    "name": "TripleStacks Turbo",
    "start": "5:15pm",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Thursdays",
    "name": "Double Green Chip Bounty",
    "start": "7:15pm",
    "buyin": "$160",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Thursdays",
    "name": "QuadStacks",
    "start": "11:15am",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Tuesdays",
    "name": "QuadStacks w/ $50 Bounty",
    "start": "7:15pm",
    "buyin": "$200",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Tuesdays",
    "name": "TripleStacks",
    "start": "11:15am",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Wednesdays",
    "name": "Double Board Bomb Pot PLO",
    "start": "7:15pm",
    "buyin": "$140",
    "state": "Maryland"
  },
  {
    "casino": "Maryland Live! Casino",
    "day": "Wednesdays",
    "name": "Double GreenChip Bounty",
    "start": "11:15am",
    "buyin": "$160",
    "state": "Maryland"
  },
  {
    "casino": "Merced Poker Room",
    "day": "Saturdays",
    "name": "Saturday Tournament",
    "start": "1:00pm",
    "buyin": "$32",
    "state": "California"
  },
  {
    "casino": "Merced Poker Room",
    "day": "Wednesdays",
    "name": "Wednesday Tournament",
    "start": "6:00pm",
    "buyin": "$52",
    "state": "California"
  },
  {
    "casino": "MGM Grand, Detroit",
    "day": "Sundays",
    "name": "NLHE Sunday Tournament",
    "start": "11:30am",
    "buyin": "$300",
    "state": "Michigan"
  },
  {
    "casino": "MGM Grand, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "7:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "MGM Grand, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "11:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "MGM Grand, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Sundays",
    "name": "Daily NLH",
    "start": "11:10am",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "MGM Grand, Las Vegas",
    "day": "Saturdays",
    "name": "Saturday NLH",
    "start": "11:10am",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Fridays",
    "name": "$160 NLH",
    "start": "11:00am",
    "buyin": "$160",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Mondays",
    "name": "$100 NLH Turbo",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Mondays",
    "name": "$180 Bounty NLH",
    "start": "6:00pm",
    "buyin": "$180",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Saturdays",
    "name": "$200 NLH",
    "start": "11:00am",
    "buyin": "$200",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Sundays",
    "name": "$260 Black Chip Bounty NLH",
    "start": "11:00am",
    "buyin": "$260",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Thursdays",
    "name": "$180 Bounty NLH",
    "start": "6:00pm",
    "buyin": "$180",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Tuesdays",
    "name": "$160 NLH",
    "start": "6:00pm",
    "buyin": "$160",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Wednesdays",
    "name": "$150 NLH Bounty Turbo",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun",
    "day": "Wednesdays",
    "name": "$160 NLH",
    "start": "6:00pm",
    "buyin": "$160",
    "state": "Connecticut"
  },
  {
    "casino": "Mohegan Sun Pocono",
    "day": "Mondays",
    "name": "Double Green Chip Bounty",
    "start": "7:00pm",
    "buyin": "$150",
    "state": "Pennsylvania"
  },
  {
    "casino": "Mohegan Sun Pocono",
    "day": "Wednesdays, Fridays",
    "name": "Green Chip Bounty",
    "start": "7:00pm",
    "buyin": "$125",
    "state": "Pennsylvania"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Fridays",
    "name": "Bounty",
    "start": "6:00pm",
    "buyin": "$180",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Fridays",
    "name": "No-Limit Hold'em",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Mondays",
    "name": "No-Limit Hold'em",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Mondays",
    "name": "Turbo",
    "start": "11:00am",
    "buyin": "$125",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Saturdays",
    "name": "No-Limit Hold'em",
    "start": "11:00am",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Thursdays",
    "name": "Bounty",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Thursdays",
    "name": "No-Limit Hold'em",
    "start": "6:00pm",
    "buyin": "$225",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Tuesdays",
    "name": "No-Limit Hold'em",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Tuesdays",
    "name": "Turbo",
    "start": "6:00pm",
    "buyin": "$125",
    "state": "Florida"
  },
  {
    "casino": "Naples Fort Myers Kennel Club & Poker Room",
    "day": "Wednesdays",
    "name": "No-Limit Hold'em",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Nineteenth Hole",
    "day": "Saturdays",
    "name": "NLH Free Roll",
    "start": "1:00pm",
    "buyin": "$5",
    "state": "California"
  },
  {
    "casino": "Nineteenth Hole",
    "day": "Sundays",
    "name": "NLH",
    "start": "1:00pm",
    "buyin": "$55",
    "state": "California"
  },
  {
    "casino": "Nineteenth Hole",
    "day": "Tuesdays",
    "name": "NLH Free Roll",
    "start": "5:30pm",
    "buyin": "$5",
    "state": "California"
  },
  {
    "casino": "Ocala Bets",
    "day": "Fridays",
    "name": "The Original $1,000 1st Place GTD",
    "start": "7:00pm",
    "buyin": "$65",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Mondays",
    "name": "Double Board Bomb Pot $60",
    "start": "11:00am",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Mondays",
    "name": "FreeRoll $500 GTD",
    "start": "6:00pm",
    "buyin": "$0",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Sundays",
    "name": "Brunch Buster GTD",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Tuesdays",
    "name": "DBBP Bounty $80",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Tuesdays",
    "name": "Reba's Re-Buy Rumble $50",
    "start": "11:00am",
    "buyin": "$50",
    "state": "Florida"
  },
  {
    "casino": "Ocala Bets",
    "day": "Wednesdays",
    "name": "Mega Monster Stack $50",
    "start": "11:00am",
    "buyin": "$50",
    "state": "Florida"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Fridays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$125 ($100+$25)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Mondays, Wednesdays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$130 ($100+$25)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Mondays, Wednesdays",
    "name": "NLH Bounty",
    "start": "6:00pm",
    "buyin": "$155 ($100+$25+$25 bounty)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Saturdays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$200 ($160+$30)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Sundays",
    "name": "NLH",
    "start": "10:00am",
    "buyin": "$150 ($110+$30)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Sundays",
    "name": "NLH Bounty",
    "start": "6:00pm",
    "buyin": "$155 ($100+$25+$25 bounty)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Tuesdays, Thursdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$130 ($100+$25)",
    "state": "California"
  },
  {
    "casino": "Ocean's 11 Casino",
    "day": "Tuesdays, Thursdays",
    "name": "NLH Bounty",
    "start": "10:00am",
    "buyin": "$155 ($100+$25+$25 bounty)",
    "state": "California"
  },
  {
    "casino": "Oceanview Card Room",
    "day": "Saturdays (1st of month)",
    "name": "1st Saturday",
    "start": "3:30pm",
    "buyin": "$190",
    "state": "California"
  },
  {
    "casino": "Oceanview Card Room",
    "day": "Sundays (1st of month)",
    "name": "1st Sunday",
    "start": "3:30pm",
    "buyin": "$190",
    "state": "California"
  },
  {
    "casino": "Oceanview Card Room",
    "day": "Tuesdays (1st of month)",
    "name": "1st Tuesday",
    "start": "5:00pm",
    "buyin": "$190",
    "state": "California"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Fridays",
    "name": "$300 Rake Free",
    "start": "1:00pm",
    "buyin": "$300",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Fridays",
    "name": "$45 Friday Night Madness",
    "start": "6:30pm",
    "buyin": "$45",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Saturdays",
    "name": "$100 Madness",
    "start": "6:30pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Saturdays",
    "name": "$170 Bounty",
    "start": "11:00am",
    "buyin": "$170",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Sundays",
    "name": "$120 NLH",
    "start": "1:00pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Thursdays",
    "name": "$40 Fab 40",
    "start": "1:00pm",
    "buyin": "$40",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Thursdays",
    "name": "$60 Mega Stack",
    "start": "6:30pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Tuesdays",
    "name": "$40 Fab 40",
    "start": "6:30pm",
    "buyin": "$40",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Tuesdays",
    "name": "$80 Colossus",
    "start": "1:00pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Wednesdays",
    "name": "$100 Wacky No Rake",
    "start": "6:30pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "One-Eyed Jack's Poker Room",
    "day": "Wednesdays",
    "name": "$60 Mega Stack",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "1st Thursdays",
    "name": "OC Monthly Tournament",
    "start": "7:10pm",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Fridays",
    "name": "$165 GAPT Double Green Chip Bounty NLH",
    "start": "3:10pm",
    "buyin": "$165",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Mondays",
    "name": "$130 Triple Stack Turbo NLH",
    "start": "7:10pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Saturdays",
    "name": "$100 PLO High Only Double Board Bomb Pot",
    "start": "12:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Sundays",
    "name": "$100 Green Chip Bounty NLH",
    "start": "7:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Thursdays",
    "name": "$100 GAPT Double Stack Turbo NLH",
    "start": "7:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Tuesdays",
    "name": "$100 Double Board Bomb Pot NLH",
    "start": "7:10pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Orange City Racing and Card Club",
    "day": "Wednesdays",
    "name": "$130 Deep Stack NLH",
    "start": "12:10pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Outlaws Card Parlour",
    "day": "Saturdays",
    "name": "$120 Freezeout Hold'em Tournament",
    "start": "4:00pm",
    "buyin": "$120",
    "state": "California"
  },
  {
    "casino": "Outlaws Card Parlour",
    "day": "Saturdays",
    "name": "$40 NLH Tournament",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Outlaws Card Parlour",
    "day": "Sundays",
    "name": "$40 NLH Rebuy Tournament",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Outlaws Card Parlour",
    "day": "Wednesdays",
    "name": "$20 NLH Rebuy Tournament",
    "start": "6:00pm",
    "buyin": "$20",
    "state": "California"
  },
  {
    "casino": "Oxford Downs",
    "day": "Fridays",
    "name": "Friday Duckie's NLH",
    "start": "10:15am",
    "buyin": "$35",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Fridays",
    "name": "Friday Night Green Chip Bounty NLH",
    "start": "6:15pm",
    "buyin": "$135",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Last Saturdays",
    "name": "Monster Stack NLH",
    "start": "11:15am",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Mondays",
    "name": "Monday Night NLH Turbo",
    "start": "6:15pm",
    "buyin": "$45",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Mondays",
    "name": "Shirley's Seniors NLH (50+)",
    "start": "11:15am",
    "buyin": "$35",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Sundays",
    "name": "Sunday Night Deep Stack Turbo NLH",
    "start": "6:15pm",
    "buyin": "$65",
    "state": "Florida"
  },
  {
    "casino": "Oxford Downs",
    "day": "Sundays",
    "name": "Super Deep Stack NLH",
    "start": "11:15am",
    "buyin": "$65",
    "state": "Florida"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Fridays",
    "name": "Friday Night Re-Entry $10K GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Mondays",
    "name": "Monday Green Chip Bounty $5K GTD",
    "start": "6:00pm",
    "buyin": "$125",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Breakfast Club Morning Turbo",
    "start": "10:00am",
    "buyin": "$45",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Daily NLH $2K GTD",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Saturdays",
    "name": "Palace Powerstack $30K GTD",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Sundays",
    "name": "Sunday Saddle-Up $20K GTD",
    "start": "11:00am",
    "buyin": "$120",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Thursdays",
    "name": "PLO Deep Stack $3K GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "Palace Poker Texas",
    "day": "Wednesdays",
    "name": "Wednesday Nightly $3K GTD",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Texas"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Fridays",
    "name": "$130 NLH $3K GTD",
    "start": "6:15pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Fridays",
    "name": "$150 NLH $15K GTD",
    "start": "11:15am",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Mondays",
    "name": "$100 Turbo NLH $2K GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Mondays",
    "name": "$125 NLH $25 Bounty $3K GTD",
    "start": "11:15am",
    "buyin": "$125",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Saturdays",
    "name": "$100 NLH $2K GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Saturdays",
    "name": "$300 Deep Stack NLH $10K GTD",
    "start": "11:15am",
    "buyin": "$300",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Sundays",
    "name": "$160 NLH $5K GTD",
    "start": "12:15pm",
    "buyin": "$160",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Thursdays",
    "name": "$100 Turbo NLH $2K GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Thursdays",
    "name": "$200 PLO Mega Deepstack $5K GTD",
    "start": "11:15am",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Tuesdays",
    "name": "$100 PLO $2K GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Tuesdays",
    "name": "$130 NLH $2K GTD",
    "start": "11:15am",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Wednesdays",
    "name": "$130 NLH $5K GTD",
    "start": "11:15am",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Palm Beach Kennel Club, West Palm Beach",
    "day": "Wednesdays",
    "name": "$130 NLH Survivor $3K GTD",
    "start": "6:15pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "1st Saturdays",
    "name": "$3,000 Guaranteed Championship NLH",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "Fridays",
    "name": "Bounty Hunter NLH",
    "start": "10:00am",
    "buyin": "$75",
    "state": "California"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "Mondays",
    "name": "3K Qualifier NLH",
    "start": "10:00am",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "Sundays",
    "name": "3K Qualifier NLH",
    "start": "11:00am",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "Wednesdays",
    "name": "2K Guaranteed NLH",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Parkwest Casino Lodi",
    "day": "Wednesdays",
    "name": "3K Qualifier NLH",
    "start": "10:00am",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Parx Casino",
    "day": "Fridays",
    "name": "NLH",
    "start": "11:15am",
    "buyin": "$340",
    "state": "Pennsylvania"
  },
  {
    "casino": "Parx Casino",
    "day": "Mondays",
    "name": "Double Green Chip Bounty",
    "start": "6:15pm",
    "buyin": "$200",
    "state": "Pennsylvania"
  },
  {
    "casino": "Parx Casino",
    "day": "Sundays",
    "name": "Turbo",
    "start": "11:15am",
    "buyin": "$150",
    "state": "Pennsylvania"
  },
  {
    "casino": "Players Casino",
    "day": "Mondays",
    "name": "$150 NLHE Bounty",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Players Casino",
    "day": "Sundays",
    "name": "$180 NLHE",
    "start": "12:00pm",
    "buyin": "$180",
    "state": "California"
  },
  {
    "casino": "Players Casino",
    "day": "Sundays",
    "name": "$60 NLHE",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Players Casino",
    "day": "Thursdays",
    "name": "$180 NLHE",
    "start": "6:00pm",
    "buyin": "$180",
    "state": "California"
  },
  {
    "casino": "Players Casino",
    "day": "Thursdays",
    "name": "$60 NLHE",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Players Casino",
    "day": "Tuesdays",
    "name": "$60 NLHE",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Poker House Fort Worth",
    "day": "Daily",
    "name": "Noon Freeroll NL Holdem",
    "start": "12:00pm",
    "buyin": "Free",
    "state": "Texas"
  },
  {
    "casino": "Poker House Fort Worth",
    "day": "Thursdays",
    "name": "$65 NL Holdem",
    "start": "6:30pm",
    "buyin": "$65",
    "state": "Texas"
  },
  {
    "casino": "Prairie Meadows",
    "day": "Sundays",
    "name": "No Limit Texas Hold'em",
    "start": "4:15pm",
    "buyin": "$55+$15",
    "state": "Iowa"
  },
  {
    "casino": "Prairie Meadows",
    "day": "Thursdays",
    "name": "No Limit Texas Hold'em",
    "start": "6:15pm",
    "buyin": "$55+$15",
    "state": "Iowa"
  },
  {
    "casino": "Razzals Bar & Grill",
    "day": "Thursdays",
    "name": "$25 NL Holdem Bounty",
    "start": "7:00pm",
    "buyin": "$25",
    "state": "Washington"
  },
  {
    "casino": "Red Rock Casino Resort & Spa",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
    "name": "Daily No-Limit Hold'em",
    "start": "11:05am",
    "buyin": "$85",
    "state": "Nevada"
  },
  {
    "casino": "Red Rock Casino Resort & Spa",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
    "name": "Daily No-Limit Hold'em",
    "start": "6:05pm",
    "buyin": "$85",
    "state": "Nevada"
  },
  {
    "casino": "Red Rock Casino Resort & Spa",
    "day": "Sundays",
    "name": "Sunday Funday Bounty NLH",
    "start": "11:05am",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "Rivers Casino",
    "day": "Fridays",
    "name": "Deep Stack Turbo",
    "start": "7:00pm",
    "buyin": "$150",
    "state": "Pennsylvania"
  },
  {
    "casino": "Rivers Casino",
    "day": "Fridays, Sundays",
    "name": "NLH",
    "start": "12:00pm",
    "buyin": "$125",
    "state": "Pennsylvania"
  },
  {
    "casino": "Rivers Casino",
    "day": "Wednesdays",
    "name": "Double Green Chip Bounty",
    "start": "4:00pm",
    "buyin": "$160",
    "state": "Pennsylvania"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Fridays",
    "name": "$150 Friday Semi-Turbo",
    "start": "11:15am",
    "buyin": "$120+$30",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Mondays",
    "name": "$90 Monday Morning Turbo",
    "start": "11:15am",
    "buyin": "$70+$20",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Mondays",
    "name": "$90 Monday Night Turbo",
    "start": "6:15pm",
    "buyin": "$70+$20",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Saturdays",
    "name": "$230 Double Green Chip",
    "start": "11:15am",
    "buyin": "$150+$50 bounty+$30",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Sundays",
    "name": "$340 Sunday Survivor NLH",
    "start": "11:15am",
    "buyin": "$300+$40",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino Portsmouth",
    "day": "Wednesdays",
    "name": "$145 Green Chip Bounty/Survivor",
    "start": "11:15am",
    "buyin": "$100+$25 bounty+$20",
    "state": "Virginia"
  },
  {
    "casino": "Rivers Casino, Des Plaines",
    "day": "Mondays",
    "name": "No-Limit Texas Hold'em Tournament",
    "start": "11am",
    "buyin": "$250",
    "state": "Illinois"
  },
  {
    "casino": "Roxbury Lanes Casino",
    "day": "Wednesdays, Thursdays",
    "name": "$50 NL Holdem $200 Added",
    "start": "12:00pm",
    "buyin": "$50",
    "state": "Washington"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "1st Sundays",
    "name": "Pot Limit Omaha",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Fridays",
    "name": "The Double Stack",
    "start": "10:00am",
    "buyin": "$200",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Fridays",
    "name": "The Player's Special",
    "start": "5:00pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Mondays",
    "name": "Monday Free Poker Tournament",
    "start": "6:00pm",
    "buyin": "Free",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Mondays",
    "name": "The 50/50",
    "start": "10:00am",
    "buyin": "$50",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Mondays",
    "name": "The 50/50",
    "start": "1:00pm",
    "buyin": "$50",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Saturdays",
    "name": "Double Green Chip Bounty",
    "start": "5:00pm",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Saturdays",
    "name": "The Player's Special",
    "start": "10:00am",
    "buyin": "$150",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Sundays",
    "name": "The Eighty",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Sundays",
    "name": "The Royal Double Stack",
    "start": "1:00pm",
    "buyin": "$250",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Thursdays",
    "name": "The Double Stack",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Thursdays",
    "name": "The Splash Pot",
    "start": "10:00am",
    "buyin": "$90",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Tuesdays",
    "name": "The Double Stack",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Tuesdays",
    "name": "The Seventy Five",
    "start": "10:00am",
    "buyin": "$75",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Wednesdays",
    "name": "The 60/60 Bounty",
    "start": "10:00am",
    "buyin": "$60",
    "state": "Minnesota"
  },
  {
    "casino": "Running Aces Casino & Racetrack",
    "day": "Wednesdays",
    "name": "The Eighty",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Minnesota"
  },
  {
    "casino": "Saracen Casino Resort",
    "day": "Fridays",
    "name": "Weekly Tournament",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Arkansas"
  },
  {
    "casino": "Saracen Casino Resort",
    "day": "Mondays",
    "name": "Weekly Tournament",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "Arkansas"
  },
  {
    "casino": "Saracen Casino Resort",
    "day": "Saturdays",
    "name": "Weekly Tournament",
    "start": "4:00pm",
    "buyin": "$135",
    "state": "Arkansas"
  },
  {
    "casino": "Saracen Casino Resort",
    "day": "Sundays",
    "name": "Weekly Tournament",
    "start": "1:00pm",
    "buyin": "$75",
    "state": "Arkansas"
  },
  {
    "casino": "Saracen Casino Resort",
    "day": "Thursdays",
    "name": "Weekly Tournament",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "Arkansas"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Fridays",
    "name": "Friday Evening Double Green Chip Bounty $10K GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Fridays",
    "name": "Friday Morning Crazy Pineapple Survivor $2.4K GTD",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Mondays",
    "name": "Monday Evening Double Green Chip Bounty $10K GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Mondays",
    "name": "Monday Morning Survivor NLH $2.4K GTD",
    "start": "11:00am",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Saturdays",
    "name": "Saturday Evening Deep Stack NLH $2.5K GTD",
    "start": "6:00pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Saturdays",
    "name": "Saturday Morning Triple Stack NLH $5K GTD",
    "start": "10:00am",
    "buyin": "$140",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Sundays",
    "name": "Sunday Evening Crazy Pineapple $2.5K GTD",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Sundays",
    "name": "Sunday Morning Turbo Bounty NLH $5K GTD",
    "start": "10:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Thursdays",
    "name": "Thursday Evening Bombpot Turbo NLH",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Thursdays",
    "name": "Thursday Morning Turbo Bounty NLH $2K GTD",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Tuesdays",
    "name": "Tuesday Evening Turbo Bounty NLH $2.5K GTD",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Tuesdays",
    "name": "Tuesday Morning Omaha Hi-Lo $2K GTD",
    "start": "11:00am",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Wednesdays",
    "name": "Wednesday Evening Deep Stack NLH $10K GTD",
    "start": "6:00pm",
    "buyin": "$130",
    "state": "Florida"
  },
  {
    "casino": "Seminole Casino, Coconut Creek",
    "day": "Wednesdays",
    "name": "Wednesday Morning Re-Do NLH Turbo $2K GTD",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Fridays",
    "name": "Deep Stack Green Chip Bounty $10,000 GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Fridays",
    "name": "Deep Stack Survivor $5,000 GTD",
    "start": "11:00am",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Mondays",
    "name": "Deep Stack NLHE $30,000 GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Saturdays",
    "name": "Deep Stack NLHE",
    "start": "11:00am",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Sundays",
    "name": "Triple Stack NLHE $5,000 GTD",
    "start": "12:00pm",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Thursdays",
    "name": "Triple Stack NLHE $20,000 GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Tuesdays",
    "name": "Deep Stack Double Green Chip Bounty $5,000 GTD",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Tuesdays",
    "name": "Quad Stack NLHE $20,000 GTD",
    "start": "6:00pm",
    "buyin": "$250",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Hollywood",
    "day": "Wednesdays",
    "name": "Quad Stack Double Green Chip Bounty (Freeze-Out)",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Fridays",
    "name": "Quad Stack Double Green Chip Bounty NLHE $10,000 GTD",
    "start": "6:00pm",
    "buyin": "$150+$50",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Mondays, Tuesdays, Wednesdays, Fridays",
    "name": "NLHE $2,000 GTD",
    "start": "11:00am",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Saturdays",
    "name": "Triple 30s NLHE $30,000 GTD",
    "start": "11:00am",
    "buyin": "$250",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Sundays",
    "name": "Monster Stack Black Chip Bounty NLHE $10,000 GTD",
    "start": "12:00pm",
    "buyin": "$200+$100",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Sundays (alternating)",
    "name": "Bankroll Builder NLHE $10,000 GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Thursdays",
    "name": "Deep Stack NLHE $3,000 GTD",
    "start": "11:00am",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Tuesdays",
    "name": "NLHE $3,000 GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Florida"
  },
  {
    "casino": "Seminole Hard Rock Hotel & Casino, Tampa",
    "day": "Wednesdays",
    "name": "PLO",
    "start": "6:00pm",
    "buyin": "$160",
    "state": "Florida"
  },
  {
    "casino": "Shuffle 214",
    "day": "Fridays",
    "name": "$5,000 GTD Friday Double Board PLO $50 Entry",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 214",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Weekday Freeroll $1,200 GTD",
    "start": "2:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 214",
    "day": "Sundays",
    "name": "$150 Sunday Showdown $10,000 GTD",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 214",
    "day": "Thursdays",
    "name": "$3,000 GTD Freeroll After Dark",
    "start": "6:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 214",
    "day": "Tuesdays",
    "name": "Tuesday Freeroll $2,000 GTD w/ PLO Bomb Pots",
    "start": "6:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 214",
    "day": "Wednesdays",
    "name": "NEW PLO Freeroll",
    "start": "6:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 512",
    "day": "Fridays",
    "name": "$3,000 GTD Freeroll Tournament",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 512",
    "day": "Mondays, Wednesdays",
    "name": "$2,000 GTD Round X Round Freeroll",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 512",
    "day": "Saturdays",
    "name": "$2,000 NLH Freeroll Tournament",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 512",
    "day": "Sundays",
    "name": "$1,500 GTD Freeroll",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Shuffle 512",
    "day": "Tuesdays, Thursdays",
    "name": "$2,000 GTD NLH Freeroll",
    "start": "7:00pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Slo Pitch Pub & Eatery",
    "day": "Fridays, Saturdays",
    "name": "$35 Blitz",
    "start": "11:00am",
    "buyin": "$35",
    "state": "Washington"
  },
  {
    "casino": "Slo Pitch Pub & Eatery",
    "day": "Saturday",
    "name": "$160 Saturday NLH",
    "start": "4:00pm",
    "buyin": "$160",
    "state": "Washington"
  },
  {
    "casino": "Soaring Eagle Casino & Resort",
    "day": "2nd Saturday of the month",
    "name": "No-Limit Hold'em Bounty Tournament",
    "start": "12:30pm",
    "buyin": "$300",
    "state": "Michigan"
  },
  {
    "casino": "Soaring Eagle Casino & Resort",
    "day": "Last Saturday of the month",
    "name": "Deep Stack No-Limit Hold'em Tournament",
    "start": "12:30pm",
    "buyin": "$300",
    "state": "Michigan"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "10:10am",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Fridays, Sundays",
    "name": "NLH Bounty",
    "start": "6:10pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Mondays, Thursdays",
    "name": "Crazy Pineapple Turbo",
    "start": "10:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Mondays, Thursdays, Saturdays, Sundays",
    "name": "Chip Chop Survivor",
    "start": "2:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Mondays, Tuesdays, Thursdays",
    "name": "Nightly NLH",
    "start": "6:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "Daily NLH",
    "start": "10:10am",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Tuesdays",
    "name": "Omaha 8/B",
    "start": "2:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Tuesdays, Fridays, Saturdays",
    "name": "NLH Turbo Bounty",
    "start": "10:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Wednesdays, Fridays",
    "name": "Crazy Pineapple Turbo",
    "start": "2:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Wednesdays, Saturdays",
    "name": "NLH Deep Stack",
    "start": "6:10pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "South Point Hotel, Casino & Spa",
    "day": "Wednesdays, Sundays",
    "name": "Chip Chop Survivor",
    "start": "10:10pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "Spades Poker House Baytown",
    "day": "Mondays",
    "name": "$3K GTD Freeroll",
    "start": "6:30pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Baytown",
    "day": "Thursdays",
    "name": "$3K GTD Freeroll",
    "start": "6:30pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Fridays",
    "name": "NLH",
    "start": "6:30pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Mondays",
    "name": "PLO Rebuy",
    "start": "6:30pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Saturdays",
    "name": "Weekend Mixed Format",
    "start": "2:00pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Sundays",
    "name": "Sunday NLH",
    "start": "2:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Thursdays",
    "name": "PLO Rebuy",
    "start": "6:30pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Spades Poker House Webster",
    "day": "Wednesdays",
    "name": "NLH Rebuy",
    "start": "6:00pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Stars Casino",
    "day": "Fridays",
    "name": "$160 Bounty NLH",
    "start": "12:00pm",
    "buyin": "$160",
    "state": "California"
  },
  {
    "casino": "Stars Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "$80 NLH $1,000 Guaranteed",
    "start": "12:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Stars Casino",
    "day": "Sundays",
    "name": "$20 NL Poker Tournament",
    "start": "10:00am",
    "buyin": "$20",
    "state": "California"
  },
  {
    "casino": "Stones Gambling Hall",
    "day": "Mondays, Tuesdays, Thursdays",
    "name": "$60 NLH",
    "start": "10:30am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Stones Gambling Hall",
    "day": "Saturdays",
    "name": "Saturday $100 NLH",
    "start": "10:30am",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Stones Gambling Hall",
    "day": "Tuesdays, Thursdays",
    "name": "$100 NLH",
    "start": "6:30pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Stones Gambling Hall",
    "day": "Wednesdays",
    "name": "Wednesday $60 NLH",
    "start": "10:30am",
    "buyin": "$60",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Fridays",
    "name": "Two Chip Bounty NLH",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Mondays, Thursdays",
    "name": "NLH",
    "start": "6:00pm",
    "buyin": "$75",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Mondays, Wednesdays, Fridays",
    "name": "NLH",
    "start": "12:00pm",
    "buyin": "$55",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Saturdays",
    "name": "NLH",
    "start": "4:00pm",
    "buyin": "$80",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Sundays",
    "name": "Rebuy/Add-on NLH",
    "start": "4:00pm",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Tuesdays",
    "name": "Bounty",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Tuesdays, Thursdays, Sundays",
    "name": "NLH Deep Stack Rebuy",
    "start": "12:00pm",
    "buyin": "$20",
    "state": "California"
  },
  {
    "casino": "Sycuan Casino",
    "day": "Wednesdays",
    "name": "Rebuy/Add-on NLH",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Talking Stick",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Weekday Morning NLHE",
    "start": "11:15am",
    "buyin": "$125",
    "state": "Arizona"
  },
  {
    "casino": "Talking Stick",
    "day": "Saturdays",
    "name": "Super Stack NLHE",
    "start": "7:15pm",
    "state": "Arizona"
  },
  {
    "casino": "Talking Stick",
    "day": "Thursdays",
    "name": "Progressive Bounty NLHE",
    "start": "7:15pm",
    "state": "Arizona"
  },
  {
    "casino": "Talking Stick",
    "day": "Tuesdays, Fridays",
    "name": "Evening NLHE",
    "start": "7:15pm",
    "buyin": "$200",
    "state": "Arizona"
  },
  {
    "casino": "Talking Stick",
    "day": "Wednesdays",
    "name": "Crazy Pineapple",
    "start": "7:15pm",
    "state": "Arizona"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Fridays",
    "name": "$100 Super Stack",
    "start": "1:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Fridays",
    "name": "$60 Friday",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Mondays",
    "name": "$180 Super Stack",
    "start": "6:00pm",
    "buyin": "$180",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Mondays",
    "name": "$60 Satellite",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Saturdays",
    "name": "$120 Super Stack",
    "start": "1:00pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Saturdays",
    "name": "$60 Super Stack",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Sundays",
    "name": "$60 Super Stack Blitz",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Sundays",
    "name": "$80 Super Stack",
    "start": "7:00pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Thursdays",
    "name": "$60 Satellite",
    "start": "7:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Thursdays",
    "name": "$80 Super Stack",
    "start": "1:00pm",
    "buyin": "$80",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Tuesdays",
    "name": "$45 Player Appreciation",
    "start": "7:00pm",
    "buyin": "$45",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Tuesdays",
    "name": "$60 Super Stack Blitz",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Tuesdays",
    "name": "$85 Bay Area Poker Club",
    "start": "6:30pm",
    "buyin": "$85",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Wednesdays",
    "name": "$125 Silks Bounty",
    "start": "7:00pm",
    "buyin": "$125",
    "state": "Florida"
  },
  {
    "casino": "Tampa Bay Downs",
    "day": "Wednesdays",
    "name": "$60 Super Stack Blitz",
    "start": "1:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Fridays",
    "name": "TGIF",
    "start": "6:00pm",
    "buyin": "$140",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Fridays, Sundays",
    "name": "Daily Bankroll Builder XXL",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Mondays",
    "name": "Re-buy Roundup",
    "start": "6:00pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "Daily Bankroll Builder",
    "start": "12:00pm",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Saturdays",
    "name": "Mega Stack",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Sundays",
    "name": "PKO Bounty",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Thursdays",
    "name": "Almost Freezeout",
    "start": "6:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Tuesdays",
    "name": "Pot Limit Big O",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Austin",
    "day": "Wednesdays",
    "name": "Triple Stack",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Las Colinas",
    "day": "Sundays",
    "name": "Sunday DoubleStack",
    "start": "2:00pm",
    "buyin": "$150",
    "state": "Texas"
  },
  {
    "casino": "TCH Social Las Colinas",
    "day": "Sundays, Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays",
    "name": "Morning Mayhem",
    "start": "9:00am",
    "buyin": "$60",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Dallas",
    "day": "Thursdays",
    "name": "Green Chip Bounty",
    "start": "11:00am",
    "buyin": "$125",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Dallas",
    "day": "Wednesdays",
    "name": "PLO Bomb Pots",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Fridays",
    "name": "Friday Mayhem Special",
    "start": "6:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Mondays",
    "name": "$25 NLH",
    "start": "6:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Saturdays",
    "name": "$80 NLH",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Saturdays",
    "name": "PLO Blitz",
    "start": "2:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Sundays",
    "name": "$140 NLH",
    "start": "2:00pm",
    "buyin": "$140",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Thursdays",
    "name": "$140 NLH",
    "start": "6:00pm",
    "buyin": "$140",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Tuesdays",
    "name": "$80 NLH",
    "start": "6:00pm",
    "buyin": "$80",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Houston",
    "day": "Wednesdays",
    "name": "$25 NLH",
    "start": "6:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Rio Grande Valley",
    "day": "Fridays",
    "name": "Friday Night Lights",
    "start": "6:00pm",
    "buyin": "Free",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Rio Grande Valley",
    "day": "Mondays",
    "name": "Monday Night Showdown",
    "start": "6:00pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Rio Grande Valley",
    "day": "Sundays",
    "name": "Sunday Kickoff",
    "start": "6:00pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Rio Grande Valley",
    "day": "Thursdays",
    "name": "Thursday Night Blitz",
    "start": "6:00pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Rio Grande Valley",
    "day": "Tuesdays",
    "name": "PLO Freeroll",
    "start": "6:00pm",
    "buyin": "Free",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Fridays",
    "name": "Friday Turbo",
    "start": "2:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Fridays",
    "name": "Spring Standard",
    "start": "5:00pm",
    "buyin": "$140",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Mondays",
    "name": "Mega Monday",
    "start": "6:00pm",
    "buyin": "$140",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Mondays",
    "name": "Monday Turbo",
    "start": "2:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Saturdays",
    "name": "$40 to Fortune",
    "start": "2:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Sundays",
    "name": "Sunday Funday",
    "start": "2:00pm",
    "buyin": "$25",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Thursdays",
    "name": "Super Thursday",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "Texas Card House Spring",
    "day": "Tuesdays",
    "name": "Super Tuesday",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "Texas"
  },
  {
    "casino": "The Aviator Casino",
    "day": "Wednesdays",
    "name": "Mexican Poker",
    "start": "6:00pm",
    "buyin": "$30",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Fridays",
    "name": "Quantum Reload Session A",
    "start": "12:00pm",
    "buyin": "$27+$13",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Fridays",
    "name": "Quantum Reload Session B",
    "start": "2:10pm",
    "buyin": "$37+$13",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Nooner",
    "start": "12:00pm",
    "buyin": "$40+$10",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Saturdays",
    "name": "Quantum Reload Session A",
    "start": "12:00pm",
    "buyin": "$37+$13",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Saturdays",
    "name": "Quantum Reload Session B",
    "start": "2:00pm",
    "buyin": "$50+$15",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Saturdays",
    "name": "Quantum Reload Session C",
    "start": "4:00pm",
    "buyin": "$60+$20",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Sundays",
    "name": "Quantum Reload Session A",
    "start": "12:00pm",
    "buyin": "$37+$13",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Sundays",
    "name": "Quantum Reload Session B",
    "start": "2:00pm",
    "buyin": "$50+$15",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Sundays",
    "name": "Quantum Reload Session C",
    "start": "4:00pm",
    "buyin": "$60+$20",
    "state": "California"
  },
  {
    "casino": "The Bicycle Hotel & Casino",
    "day": "Thursdays, Fridays, Saturdays",
    "name": "Late Nite Madness Bounty",
    "start": "10:00pm",
    "buyin": "$50+$10",
    "state": "California"
  },
  {
    "casino": "The Big Easy Casino",
    "day": "Mondays, Wednesdays",
    "name": "$30 NLH",
    "start": "7:00pm",
    "buyin": "$30",
    "state": "Florida"
  },
  {
    "casino": "The Big Easy Casino",
    "day": "Tuesdays, Thursdays",
    "name": "$50 NLH",
    "start": "7:00pm",
    "buyin": "$50",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Fridays",
    "name": "Friday $200 / $15K GTD",
    "start": "6:00pm",
    "buyin": "$200",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Mondays",
    "name": "Monday Deepstack $120 / $5K GTD",
    "start": "6:00pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Saturdays",
    "name": "Saturday $20 / $4K GTD Rebuy",
    "start": "4:00pm",
    "buyin": "$20",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Thursdays",
    "name": "Thursday Deepstack $120 / $5K GTD",
    "start": "6:00pm",
    "buyin": "$120",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Tuesdays",
    "name": "Tuesday $100 / $5K GTD",
    "start": "6:00pm",
    "buyin": "$100",
    "state": "Florida"
  },
  {
    "casino": "The Casino @ Dania Beach",
    "day": "Wednesdays",
    "name": "Wednesday $60 / $4K GTD",
    "start": "6:00pm",
    "buyin": "$60",
    "state": "Florida"
  },
  {
    "casino": "The Fort Card Room",
    "day": "Mondays",
    "name": "$100 FL Omaha",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "The Fort Card Room",
    "day": "Saturdays",
    "name": "$100 NL Holdem",
    "start": "2:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "The Fort Card Room",
    "day": "Thursdays",
    "name": "$100 NL Holdem",
    "start": "7:00pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Fridays",
    "name": "Daily NLH Bounty $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Fridays",
    "name": "Friday Deep Stack NLH $20K GTD",
    "start": "5:00pm",
    "buyin": "$300 ($250+$30+$20)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Mondays",
    "name": "Daily NLH $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Saturdays",
    "name": "Saturday NLH $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Sundays",
    "name": "Sunday NLH Bounty $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Thursdays",
    "name": "Daily NLH $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Tuesdays",
    "name": "Tuesday Afternoon NLH $5K GTD",
    "start": "12:15pm",
    "buyin": "$75 ($65+$10)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Tuesdays",
    "name": "Tuesday Night NLH Bounty $5K GTD",
    "start": "6:45pm",
    "buyin": "$75 ($65+$10)",
    "state": "California"
  },
  {
    "casino": "The Gardens Casino",
    "day": "Wednesdays",
    "name": "Daily NLH Bounty $10K GTD",
    "start": "11:00am",
    "buyin": "$130 ($100+$18+$12)",
    "state": "California"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Fridays",
    "name": "$2.5K GTD NLH Freeroll",
    "start": "5:15pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Mondays",
    "name": "$5K GTD NLH",
    "start": "5:15pm",
    "buyin": "$50",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Saturdays",
    "name": "$5K GTD NLH",
    "start": "5:15pm",
    "buyin": "$50",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Sundays",
    "name": "$2K GTD NLH",
    "start": "5:15pm",
    "buyin": "$20",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Thursdays",
    "name": "$1.5K GTD ROE Freeroll",
    "start": "5:15pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Tuesdays",
    "name": "$1K GTD NLH Freeroll",
    "start": "5:15pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "The Hangar Poker House",
    "day": "Wednesdays",
    "name": "$1.5K GTD NLH Freeroll",
    "start": "5:15pm",
    "buyin": "$0",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "2nd Saturday of the month",
    "name": "The Big One Re-Entry",
    "start": "12:15pm",
    "buyin": "$360",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "3rd Saturday of the month",
    "name": "The Art of Poker",
    "start": "12:15pm",
    "buyin": "$250",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "Fridays",
    "name": "Friday Freeroll",
    "start": "6:15pm",
    "buyin": "$120",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "Sundays",
    "name": "Sunday Deep Stack",
    "start": "12:15pm",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "Thursdays",
    "name": "Thursday Freeroll",
    "start": "6:15pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club Round Rock",
    "day": "Tuesdays",
    "name": "Texas Freeroll",
    "start": "6:15pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club San Antonio",
    "day": "Mondays",
    "name": "Monday Night Poker $2K GTD",
    "start": "7:15pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club San Antonio",
    "day": "Sundays",
    "name": "$30 Nightly Freeroll $1K GTD",
    "start": "4:15pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club San Antonio",
    "day": "Tuesdays, Thursdays",
    "name": "$30 Nightly Freeroll $1K GTD",
    "start": "8:30pm",
    "buyin": "$30",
    "state": "Texas"
  },
  {
    "casino": "The Lodge Card Club San Antonio",
    "day": "Wednesdays",
    "name": "Wednesday Night Freezeout $5K GTD",
    "start": "6:15pm",
    "buyin": "$100",
    "state": "Texas"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Fridays",
    "name": "20K Friday Night Monster Stack",
    "start": "6:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Fridays",
    "name": "Omaha-8",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Mondays",
    "name": "H.O.R.S.E.",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Mondays, Tuesdays, Thursdays",
    "name": "Monster Stack NLH",
    "start": "6:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays",
    "name": "Super Stack NLH",
    "start": "11:05am",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Saturdays",
    "name": "Monster Stack NLH",
    "start": "11:05am",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Saturdays",
    "name": "NLH Bounty",
    "start": "6:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Saturdays",
    "name": "Triple-Triple Draw",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Sundays",
    "name": "50k Sunday Special Super Stack",
    "start": "11:05am",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Sundays",
    "name": "Big-O",
    "start": "6:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Thursdays",
    "name": "T.O.E.",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Tuesdays",
    "name": "T.O.R.S.E.",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Wednesdays",
    "name": "O.E. (Omaha-8 / Stud-8)",
    "start": "4:05pm",
    "buyin": "$150",
    "state": "Nevada"
  },
  {
    "casino": "The Orleans Hotel & Casino",
    "day": "Wednesdays",
    "name": "Super Stack NLH",
    "start": "6:05pm",
    "buyin": "$120",
    "state": "Nevada"
  },
  {
    "casino": "The Sands Casino, Bethlehem",
    "day": "Fridays",
    "name": "Friday Progressive Bounty NLH",
    "start": "11:15am",
    "buyin": "$100+$25+$25",
    "state": "Pennsylvania"
  },
  {
    "casino": "The Sands Casino, Bethlehem",
    "day": "Mondays",
    "name": "Monday Green Chip Bounty NLH",
    "start": "11:15am",
    "buyin": "$100+$25 bounty",
    "state": "Pennsylvania"
  },
  {
    "casino": "The Sands Casino, Bethlehem",
    "day": "Sundays",
    "name": "Sunday Black Chip Bounty NLH",
    "start": "11:15am",
    "buyin": "$150+$100 bounty",
    "state": "Pennsylvania"
  },
  {
    "casino": "The Sands Casino, Bethlehem",
    "day": "Thursdays",
    "name": "Thursday Green Chip Bounty NLH",
    "start": "7:15pm",
    "buyin": "$100+$25 bounty",
    "state": "Pennsylvania"
  },
  {
    "casino": "The Sands Casino, Bethlehem",
    "day": "Tuesdays",
    "name": "Tuesday Progressive Bounty NLH",
    "start": "7:15pm",
    "buyin": "$100+$25+$25",
    "state": "Pennsylvania"
  },
  {
    "casino": "The Venetian",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "$200 NLH Bounty $10K GTD",
    "start": "5:10pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Fridays",
    "name": "Friday Evening NLH",
    "start": "5:30pm",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Fridays",
    "name": "Friday NLH $10K GTD",
    "start": "9:30am",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Mondays, Tuesdays, Wednesdays",
    "name": "Daily NLH",
    "start": "9:30am",
    "buyin": "$75",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Saturdays",
    "name": "Saturday NLH $20K GTD",
    "start": "9:30am",
    "buyin": "$250",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Sundays",
    "name": "Sunday Morning NLH",
    "start": "9:30am",
    "buyin": "$40",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Sundays",
    "name": "Sunday Night Knockout",
    "start": "5:30pm",
    "buyin": "$200",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Thursdays",
    "name": "Thursday Knockout",
    "start": "9:30am",
    "buyin": "$100",
    "state": "California"
  },
  {
    "casino": "Thunder Valley Casino",
    "day": "Wednesdays",
    "name": "Wednesday Stacked Unlimited",
    "start": "5:30pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Towers Casino & Card Room",
    "day": "Sundays",
    "name": "Lucky Re-Buy Sunday NLH",
    "start": "3:00pm",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Towers Casino & Card Room",
    "day": "Sundays (first each month)",
    "name": "Super Sunday NLH (1st Sunday)",
    "start": "3:00pm",
    "buyin": "$150",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Fridays",
    "name": "$35 NLH Turbo",
    "start": "10:00am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Mondays",
    "name": "$35 NLH Turbo",
    "start": "10:00am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Mondays",
    "name": "$50 NLH",
    "start": "6:00pm",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Saturdays",
    "name": "$50 NLH",
    "start": "10:00am",
    "buyin": "$50",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Sundays",
    "name": "$160 NLH Mega Satellite",
    "start": "6:00pm",
    "buyin": "$160",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Sundays",
    "name": "$45 NLH Bounty",
    "start": "10:00am",
    "buyin": "$45",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Thursdays",
    "name": "$45 NLH Bounty",
    "start": "10:00am",
    "buyin": "$45",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Tuesdays",
    "name": "$45 NLH Bounty",
    "start": "10:00am",
    "buyin": "$45",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Wednesdays",
    "name": "$35 NLH Turbo",
    "start": "10:00am",
    "buyin": "$35",
    "state": "California"
  },
  {
    "casino": "Turlock Poker Room",
    "day": "Wednesdays",
    "name": "$70 NLH",
    "start": "6:00pm",
    "buyin": "$70",
    "state": "California"
  },
  {
    "casino": "Turning Stone Resort & Casino",
    "day": "Tuesdays",
    "name": "$5,000 Guaranteed NLH with $25 Bounty",
    "start": "7:00pm",
    "buyin": "$135",
    "state": "New York"
  },
  {
    "casino": "Turning Stone Resort & Casino",
    "day": "Tuesdays",
    "name": "Double Stack Turbo NLH",
    "start": "12:00pm",
    "buyin": "$125",
    "state": "New York"
  },
  {
    "casino": "Turning Stone Resort & Casino",
    "day": "Wednesdays",
    "name": "Single Table Winner Takes All",
    "start": "12:00pm",
    "buyin": "$125",
    "state": "New York"
  },
  {
    "casino": "Turning Stone Resort & Casino",
    "day": "Wednesdays",
    "name": "Triple Stack Turbo NLH",
    "start": "7:00pm",
    "buyin": "$130",
    "state": "New York"
  },
  {
    "casino": "Westgate Las Vegas Resort & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily Crazy Pineapple",
    "start": "3:05pm",
    "buyin": "$70",
    "state": "Nevada"
  },
  {
    "casino": "Westgate Las Vegas Resort & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "12:05pm",
    "buyin": "$55",
    "state": "Nevada"
  },
  {
    "casino": "Westgate Las Vegas Resort & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "5:05pm",
    "buyin": "$70",
    "state": "Nevada"
  },
  {
    "casino": "Westgate Las Vegas Resort & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "7:05pm",
    "buyin": "$55",
    "state": "Nevada"
  },
  {
    "casino": "Westgate Las Vegas Resort & Casino",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Daily NLH",
    "start": "9:05pm",
    "buyin": "$70",
    "state": "Nevada"
  },
  {
    "casino": "Wheeling Island Hotel, Casino & Racetrack",
    "day": "Sundays",
    "name": "Bankroll Builder",
    "start": "1:00pm",
    "buyin": "$40",
    "state": "West Virginia"
  },
  {
    "casino": "Wheeling Island Hotel, Casino & Racetrack",
    "day": "Wednesdays",
    "name": "Bankroll Builder",
    "start": "6:00pm",
    "buyin": "$40",
    "state": "West Virginia"
  },
  {
    "casino": "Wynn, Las Vegas",
    "day": "Fridays",
    "name": "Friday NLH Rebuy $40K GTD",
    "start": "12:00pm",
    "buyin": "$240",
    "state": "Nevada"
  },
  {
    "casino": "Wynn, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays",
    "name": "Daily NLH $10K GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Wynn, Las Vegas",
    "day": "Mondays, Tuesdays, Wednesdays, Thursdays, Fridays, Saturdays, Sundays",
    "name": "Nightly NLH $10K GTD",
    "start": "6:00pm",
    "buyin": "$160",
    "state": "Nevada"
  },
  {
    "casino": "Wynn, Las Vegas",
    "day": "Saturdays",
    "name": "Saturday NLH $25K GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Nevada"
  },
  {
    "casino": "Wynn, Las Vegas",
    "day": "Sundays",
    "name": "Sunday NLH $25K GTD",
    "start": "12:00pm",
    "buyin": "$200",
    "state": "Nevada"
  }
];



// WEBPACK FOOTER //
// ./js/day-events.js